import { AddCustomFALabelButton } from "../utils/AddCustomFALabelButton";
import { AddFloatingViewerIconButton } from "../utils/AddFloatingViewerIconButton";
import { AddListeningMultiLineTextEdit } from "../utils/AddListeningMultiLineTextEdit";
import { AddStaticText } from "../utils/AddStaticText";
import { AddStdFALabelButton } from "../utils/AddStdFALabelButton";
import { AddViewerIconButton } from "../utils/AddViewerIconButton";
import { appstr } from "../utils/appstr";
import { BufferViewerEleHorzPos } from "../utils/BufferViewerEleHorzPos";
import { BuildFontString } from "../utils/BuildFontString";
import { CreateCanvas } from "../utils/CreateCanvas";
import { DetermineTextColor } from "../utils/DetermineTextColor";
import { Div2Floor } from "../utils/Div2Floor";
import { doDrawImage } from "../utils/doDrawImage";
import { CenterIt } from "../utils/CenterIt.js";
import { linesOverlap } from "../utils/linesOverlap.js";
import { CreatePath2D } from "../utils/CreatePath2D.js";
import { fontIconString } from "../utils/fontIconString.js";
import { MeasureTextHeight } from "../utils/MeasureTextHeight.js";
import {
  enumBasicToolModes,
  kPagingButtonMargin,
  enumButtonLabelPosition,
  enumDividerDirection,
  enumElementBorderStyle,
  enumElementLayer,
  enumFillMode,
  enumFontIconWeights,
  enumIconButtonSizing,
  enumImageIndex,
  enumMarqueeBehavior,
  enumPanelBorderStyle,
  enumPanelColors,
  enumPanelDarkColors,
  enumPanelMode,
  enumPanelRenderMode,
  enumScrollBarType,
  enumUIModes,
  enumWSInteractMode,
  gUIFont,
  kAddIcon,
  kAdminUser,
  kAlertButtonRadius,
  kArrowLeftIcon,
  kArrowRightIcon,
  kAuthorizationIcon,
  kbuttonLabelHeight,
  kChocolate,
  kCopyFileIcon,
  kCopyIcon,
  kCreateButtonColor,
  kDoubleChevronLeft,
  kDoubleChevronRight,
  kDownloadButtonColor,
  kDownloadFileIcon,
  kEllipsisIcon,
  kFramelessDropDownMarginH,
  kFramelessHeaderHeight,
  kGrayCancel,
  kIndent,
  kLargeButtonStandardSize,
  kLargeIcon,
  kLargeWideButtonStandardHeight,
  kLargeWideButtonStandardWidth,
  kMaxCanvasPanelSize,
  kMaxCanvasDrawableSize,
  kMaxPanelSize,
  kSearchIcon,
  kSegmentInterval,
  kSmallButtonStandardSize,
  kSmallIcon,
  kTabKey,
  kToggleOffIconDuo,
  kToggleOnIcon,
  kUpArrow,
  kWebFrameMargin
} from "../constants";

import {
  uFramelessPanelColor,
  uFramelessPanelColorDarker,
  uFramelessPanelColorLighter
} from "../whitelabel/brand";
import { Globals } from "./Globals";
import { fontIconStringDuotone } from "../utils/fontIconStringDuotone";
import { isInPlanning } from "../utils/isInPlanning";
import { paginateArray } from "../utils/paginateArray";
import { PTabToNextElement } from "../utils/PTabToNextElement";
import { QAnimateTextButton } from "./QAnimateTextButton";
import { QCheckbox } from "./QCheckbox";
import { QColorSetButton } from "./QColorSetButton";
import { QDivider } from "./QDivider";
import { QDividerText } from "./QDividerText";
import { QFramelessPanelDragger } from "./QFramelessPanelDragger";
import { QHoverBox } from "./QHoverBox";
import { QLargeSVGIconButton } from "./QLargeSVGIconButton";
import { QLoadingElement } from "./QLoadingElement";
import { QPadlessButton } from "./QPadlessButton";
import { QPanelCollection } from "./QPanelCollection";
import { QPanelDivider } from "./QPanelDivider";
import { QPanelHitTest } from "../utils/QPanelHitTest";
import { QPanelTabButton } from "./QPanelTabButton";
import { QPoint } from "./QPoint";
import { QRect } from "./QRect";
import { QResizeBehavior } from "../utils/QResizeBehavior";
import { QScrollBar } from "./QScrollBar";
import { QSearchStrDict } from "./QSearchStrDict";
import { QTextEdit } from "./QTextEdit";
import { QUIObject } from "./QUIObject";
import { QXIconButton } from "./QXIconButton";
import { shadeColor } from "../utils/shadeColor";
import { TruncateText } from "../utils/TruncateText";
import { isInStandardSubmode } from "../utils/isInStandardSubmode";
import { MeasureText } from "../utils/MeasureText.js";
import { QHotLinkObj } from "./QHotLinkObj.js";
import { QImageElement } from "./QImageElement.js";
import { AddBubbleButton } from "../utils/AddBubbleButton.js";
import { AddFramelessExitButton } from "../utils/AddFramelessExitButton.js";
import { AddLinkText } from "../utils/AddLinkText.js";
import { AddFramelessCopyButton } from "../utils/AddFramelessCopyButton.js";
import { AddStaticText2 } from "../utils/AddStaticText2.js";
import { QMenuButton } from "./QMenuButton.js";

export class QPanel extends QUIObject {
  constructor() {
    super();
    this.fHorzOffset = 1;
    this.fVertOffset = 1;
    this.fWidth = 1;
    this.fHeight = 1;

    this.fPortWidth = 1;
    this.fPortHeight = 1;
    this.fPanX = 0;
    this.fPanY = 0;
    //this.fInPanMode = false;
    this.fPanelMode = enumPanelMode.arrowMode;

    this.fScaleFactor = 1.0;
    this.fMaxZoom = 4.0;
    this.fMinZoom = 0.25;

    //this.fPanelModal = false;
    this.fOutsideClickDismiss = false;

    this.fShown = true;

    // Fill properties
    this.fFillColor = "#EE10EE"; // Purple
    this.fFillMode = enumFillMode.solidFill;
    this.fFillGradientStart = "white";
    this.fFillGradientEnd = "black";

    // Border properties
    this.fBorderThickness = 1;
    this.fBorderStyle = enumPanelBorderStyle.noBorder;
    this.fBorderColor = "#000000";

    // Shadow on/off
    this.fShowShadow = false;

    this.fClickX = 0;
    this.fClickY = 0;

    this.fElements = null;
    //this.fElementGroups = null;
    this.fZPlanes = null;

    //this.fLayers = [
    // [this.fElements],[],[]]

    this.fOffscreenBuffer = null;
    this.fPanelResizeBehavior = null;

    // Marquee
    this.fDoDrawMarquee = false;
    this.fMarqueeLeft = 0;
    this.fMarqueeTop = 0;
    this.fMarqueeWidth = 0;
    this.fMarqueeHeight = 0;
    this.fMarqueeEnabled = false;
    this.fMarqueeBehavior = enumMarqueeBehavior.smartOverlap;
    this.fMarqueeSelectNestedElements = false;
    // Margin handling
    //this.fMarginRect = null;

    this.fAlpha = 1.0;

    this.fDblClickCmd = null;
    this.fAltCanvas = null;

    this.fSelectionCache = null;

    this.fTabList = null;

    this.fStaticPanel = false;
    this.fForceRender = false;

    this.fGradient = null;

    this.fRenderMode = enumPanelRenderMode.all;
    this.fDragable = null;

    this.fHasHorzScrollBar = null;
    this.fHasVertScrollBar = null;
    this.fScrollBarH = null;
    this.fScrollBarV = null;

    this.fCurCursor = "default";

    this.fZLayer = null; //Default to 1 (Not 0) - 0 is reserved for background elements.
    this.fPanelCollection = null;
    this.fWindowBorderTolerance = 10; // number of pixels a panel will maintain between its edges and the browser window

    this.fDropInfo = {
      dropEnabled: false,
      dropRestrictions: [],
      dropDirectory: null
    }; // drag drop uploads

    // ctrl + shift selections on by default
    this.fShiftExtendsSelection = true;
    this.fCtrlExtendsSelection = true;

    // port panel prop controls
    this.fSourceVBuffer = 0;
    this.fSourceHBuffer = 0;
    this.fBottomBuffer = 0;
    this.fRightBuffer = 0;
    this.fDisplayPortColor = null;
    this.fNestedDisplayPort = null;
    this.fResetY = null;
    this.fCustomViewPortFormatting = false;
    this.fBasicViewPortFormatting = false;

    // admin user hot link controls
    this.fHotLinkButton = null;
    this.fHasHotLink = false;
    this.fHotLinkObj = null;
    // basic element controls
    this.fSaveStr = null;
    this.fCancelStr = null;
    this.fCancelColor = null;
    this.fResetStr = null;
    this.fCornerButtonOffset = 0;
    this.fNumPageLinksShown = 5;
    this.fDefaultMaxItemsPerPage = 100;
    this.fLargeLinks = false;
    this.fPositionPageLinkBelowPort = false;
    this.fHideScrollBar = false;
    this.fAllowPanOnElemHit = false;
    this.fNeedsRender = true;
    // Set by SizePanelAndPort when the chart is too large for the browser to draw.
    this.fCanvasSizeExceeded = false;
    this.fRequestedBufferWidth = 0;
    this.fRequestedBufferHeight = 0;
  }

  IsHoverHighlightEnabled() {
    return false;
    // Override this
  }

  BoxSelectEnabled() {
    return this.fBoxSelectEnabled;
    // Override this
  }

  BoxDragEnabled() {
    return this.fBoxDragEnabled;
    // Override this
  }

  IsElementChartBox(anElement, includeTextBox) {
    return false;
    // Override this
  }

  GetBoxCmdCode() {
    return null;
    // Override this
  }

  BoxIsControl() {
    return false;
  }

  ValidMove() {
    return false;
  }

  GenerateHotLinkObj(hotLinkMode, hotLinkSection, panelToUpdate) {
    var panelTarget = panelToUpdate ? panelToUpdate : this;
    var hotLinkObj = new QHotLinkObj();
    hotLinkObj.InitHotLinkObj(hotLinkSection, panelTarget, this.GetWSMgrRef(), hotLinkMode);
    return hotLinkObj;
  }

  InDropMode() {
    return false;
  }

  GetTabID(reset) {
    if (reset) {
      this.fTabID = 0;
    }
    return (this.fTabID += 1);
  }

  AddColorButton(x, y, cmdCode, color, hoverCode, big, secondaryFill, fillMode) {
    var aButton = new QColorSetButton();
    var sizeW = big ? kLargeButtonStandardSize : kSmallButtonStandardSize;
    var sizeH = big ? kLargeButtonStandardSize : kSmallButtonStandardSize;
    var sizing = big ? kLargeIcon : kSmallIcon;

    aButton.SetSizing(sizing);
    aButton.SizeElement(sizeW, sizeH);
    aButton.PositionElement(x, y);
    aButton.SetFillColor(color);
    aButton.SetFillColor2(secondaryFill);
    aButton.SetFillMode(fillMode ? fillMode : enumFillMode.solidFill);
    aButton.SetCmdCode(cmdCode);
    aButton.SetHoverCode(hoverCode);
    this.PushElement(aButton);
    return aButton;
  }

  AddToggleDropDown(wsMgr, header, toggleSetList, activeList, sourceElement) {
    const QToggleDropDown = require("./QToggleDropDown.js").QToggleDropDown;
    var dropDown = new QToggleDropDown();
    dropDown.fActiveSourceList = activeList;
    dropDown.InitDropDown(
      wsMgr,
      this,
      header,
      dropDown.BuildBasicOptions(toggleSetList),
      0,
      false,
      sourceElement
    );
    return dropDown;
  }

  GetElementByID(id) {
    var element = null;
    if (this.fElements == null) return element;

    for (var i = 0; i < this.fElements.length; i++) {
      if (this.fElements[i].fElementID === id) {
        return this.fElements[i];
      }
    }
    return element;
  }

  //======================================================================================================================
  AddAppImageElement(xPos, yPos, imageW, imageH, imageIdx) {
    var enabledImageIdx = enumImageIndex.appIcons;
    var xSpacing = 96,
      ySpacing = 96;
    var xSize = imageW,
      ySize = imageH;
    var yOffset = Math.floor(imageIdx / 12);
    var xOffset = imageIdx % 12;

    return this.AddSVGElem(
      enabledImageIdx,
      imageW,
      imageH,
      xPos,
      yPos,
      xOffset,
      yOffset,
      xSize,
      ySize,
      xSpacing,
      ySpacing
    );
  }

  AddConnectorImageElement(
    xPos,
    yPos,
    imageW,
    imageH,
    iconIdx,
    imageIdx = null,
    singleImage = false
  ) {
    var enabledImageIdx = imageIdx ? imageIdx : enumImageIndex.enableconnectors96;
    var xSpacing = 96,
      ySpacing = 96;
    var xSize = imageW,
      ySize = imageH;
    var yOffset = Math.floor(iconIdx / 7);
    var xOffset = iconIdx % 7;

    return this.AddSVGElem(
      enabledImageIdx,
      imageW,
      imageH,
      xPos,
      yPos,
      xOffset,
      yOffset,
      xSize,
      ySize,
      xSpacing,
      ySpacing,
      singleImage
    );
  }

  AddSVGElem(
    enabledImageIdx,
    imageW,
    imageH,
    xPos,
    yPos,
    xOffset,
    yOffset,
    xSize,
    ySize,
    xSpacing,
    ySpacing,
    singleImage = false
  ) {
    var imageMgr = this.fWSMgr.GetImageMgr();

    if (singleImage) var image = imageMgr.GetIndexImage(enabledImageIdx);
    else
      var image = imageMgr.GetSubImage(
        enabledImageIdx,
        xOffset,
        yOffset,
        xSize,
        ySize,
        xSpacing,
        ySpacing
      );

    var imageElement = new QImageElement();
    imageElement.SetImage(image);
    imageElement.SizeElement(imageW, imageH);

    imageElement.PositionElement(xPos, yPos);

    this.PushElement(imageElement);

    return imageElement;
  }

  GetImageElement(imageIdx, imageW, imageH, xPos, yPos) {
    var imageMgr = this.fWSMgr.GetImageMgr();
    var image = imageMgr.GetIndexImage(imageIdx);
    var imageElement = new QImageElement();
    imageElement.fImageMgr = imageMgr;
    imageElement.fImageFile = imageIdx;
    imageElement.SetImage(image);
    imageElement.SetDisabledImage();
    imageElement.SizeElement(imageW, imageH);
    imageElement.PositionElement(xPos, yPos);
    return imageElement;
  }

  // When the panel is removed. Give each panel a chance to cleanup
  SetWSMgrRef(wsMgr) {
    this.fWSMgr = wsMgr;
    //Override this if needed
  }

  GetWSMgrRef() {
    return this.fWSMgr;
    //Override this if needed
  }

  GetUIColors() {
    return this.fWSMgr.GetUIColors();
  }

  DoClosePanel() {
    //Override this if needed
  }

  GetBasicToolModes() {
    var allowedToolModes = [];
    var panelMode = this.GetPanelMode();
    switch (panelMode) {
      case enumPanelMode.arrowMode:
        allowedToolModes = [
          enumBasicToolModes.select,
          enumBasicToolModes.marquee,
          enumBasicToolModes.dragElem
        ];
        break;
      case enumPanelMode.marqueeMode:
        allowedToolModes = [enumBasicToolModes.marquee];
        break;
      case enumPanelMode.combinedMode:
        allowedToolModes = [enumBasicToolModes.select, enumBasicToolModes.pan];
        break;
      case enumPanelMode.panMode:
        allowedToolModes = [enumBasicToolModes.pan];
        break;
      case enumPanelMode.otherMode:
        allowedToolModes = [enumBasicToolModes.select, enumBasicToolModes.dragElem];
        break;
      case enumPanelMode.implicitMode:
        allowedToolModes = [
          enumBasicToolModes.select,
          enumBasicToolModes.dragElem,
          enumBasicToolModes.pan
        ];
        if (!isInPlanning()) allowedToolModes.push(enumBasicToolModes.marquee);
        break;
    }
    return allowedToolModes;
  }

  AllowToolMode(targetToolMode) {
    var toolModes = this.GetBasicToolModes();
    return toolModes.includes(targetToolMode);
  }

  GetColXCoordinates() {
    return this.fColArray;
  }

  SetColXCoordinates(colArray) {
    this.fColArray = colArray;
  }

  ClosePanel() {
    this.DoClosePanel();
    var numElements = this.GetNumElements();
    for (var i = 0; i < numElements; i++) {
      var theElement = this.fElements[i];
      this.DoCloseElement(theElement);
    }

    this.fElements = null;

    //if (this.fBackBuffer)
    //	document.body.removeChild(this.fOffscreenBuffer);
  }

  GetZLayer() {
    return this.fZLayer;
  }

  // Border Style
  SetZLayer(theLayer) {
    //CAUTION - must be before pushing to WSMGr!!
    this.fZLayer = theLayer;
  }

  SetAltCanvas(altCanvas) {
    this.fAltCanvas = altCanvas;
  }

  SetBackBuffer(backBuffer) {
    this.fBackBuffer = backBuffer;
  }

  // Fill methods
  SetFillMode(fillMode) {
    this.fFillMode = fillMode;
  }

  GetFillMode() {
    return this.fFillMode;
  }

  // UI Color
  SetUIColors(colorObj) {
    this.fUIColors = colorObj;
  }

  SetFillColor(theFillColor) {
    this.fFillColor = theFillColor;
  }

  GetFillColor() {
    return this.fFillColor;
  }

  SetGradientColors(startColor, endColor, middleColor) {
    this.fFillGradientStart = startColor;
    this.fFillGradientEnd = endColor;
    this.fFillMiddleColor = middleColor;
    this.fGradient = null;
  }

  SetDarkMode() {
    this.fPanelTheme = enumPanelDarkColors;
  }

  SetLightMode() {
    this.fPanelTheme = enumPanelColors;
  }

  // Border Thickness
  SetBorderThickness(thickness) {
    this.fBorderThickness = thickness;
  }

  GetBorderThickness() {
    return this.fBorderThickness;
  }

  // Border Color
  SetBorderColor(borderColor) {
    this.fBorderColor = borderColor;
  }

  GetBorderColor() {
    return this.fBorderColor;
  }

  // Border Style
  SetBorderStyle(borderStyle) {
    this.fBorderStyle = borderStyle;
  }

  GetBorderStyle() {
    return this.fBorderStyle;
  }

  // Used by round border style
  SetBorderRadius(radius) {
    this.fBorderRadius = radius;
  }

  // Shadow On/Off
  SetShadowOn(shadowOn) {
    this.fShowShadow = shadowOn;
  }

  GetShadowOn() {
    return this.fShowShadow;
  }

  // Modal Properties
  SetModalOn(modalOn) {
    this.fPanelModel = modalOn;
  }

  GetModalOn() {
    return this.fPanelModel;
  }

  SetOutsideClickDismissOn(outsideClickDismiss) {
    this.fOutsideClickDismiss = outsideClickDismiss;
  }

  GetOutsideClickDismissOn() {
    return this.fOutsideClickDismiss;
  }

  SetPanelClickCmd(cmdCode) {
    this.fClickCmd = cmdCode;
  }

  GetPanelClickCmd() {
    return this.fClickCmd;
  }

  SetPanelDblClickCmd(cmdCode) {
    this.fDblClickCmd = cmdCode;
  }

  GetPanelDblClickCmd() {
    return this.fDblClickCmd;
  }

  GetScaleFactor() {
    return this.fScaleFactor;
  }

  SetScaleFactor(scaleFactor) {
    this.fScaleFactor = scaleFactor;
  }

  SetMinMaxZoom(minZoom, maxZoom) {
    this.fMinZoom = minZoom;
    this.fMaxZoom = maxZoom;
  }

  GetMinZoom() {
    return this.fMinZoom;
  }

  GetMaxZoom() {
    return this.fMaxZoom;
  }

  DoPositionPanel(x, y) {
    //Override
  }

  // Panel Position
  PositionPanel(x, y) {
    this.DoPositionPanel(x, y);
    this.fHorzOffset = x;
    this.fVertOffset = y;
  }

  CenterOnBackgroundPanel(backgroundPanel) {
    var xPos = this.GetPositionX();
    var yPos = this.GetPositionY();
    var oldX = xPos;
    var oldY = yPos;
    if (!backgroundPanel) {
      if (this.fWSMgr && this.fWSMgr.fBackgroundPanel)
        backgroundPanel = this.fWSMgr.fBackgroundPanel;
      else if (this.fWSMgr && this.fWSMgr.fLoginPanel) backgroundPanel = this.fWSMgr.fLoginPanel;
      else console.log("oof"); //fallback to app canvas?
    }
    var x = backgroundPanel.fHorzOffset + CenterIt(backgroundPanel.GetWidth(), this.GetWidth());
    var y = backgroundPanel.fVertOffset + CenterIt(backgroundPanel.GetHeight(), this.GetHeight());
    x = x < 0 ? 0 : x; //thanks bikram.
    y = y < 0 ? 0 : y;
    this.PositionPanel(x, y);
    this.PositionAssociatePanels(oldX, oldY, x, y);
  }

  GetActualPositionX() {
    return this.fHorzOffset * Globals._dpr;
  }

  GetActualPositionY() {
    return this.fVertOffset * Globals._dpr;
  }

  GetPositionX() {
    return this.fHorzOffset;
  }

  GetPositionY() {
    return this.fVertOffset;
  }

  GetWidth() {
    return this.fWidth;
  }

  GetActualPortWidth() {
    return this.fPortWidth * Globals._dpr;
  }

  GetActualPortHeight() {
    return this.fPortHeight * Globals._dpr;
  }

  GetHeight() {
    return this.fHeight;
  }

  GetPortWidth() {
    return this.fPortWidth;
  }

  GetPortHeight() {
    return this.fPortHeight;
  }

  SizePanel(hSize, vSize) {
    if (hSize < 0) hSize = 0;
    if (vSize < 0) vSize = 0;

    // lock width to canvas width / height in mobile
    if (Globals._mobileDevice) {
      var maxW = Globals._wsMgr.GetCanvasWidth();
      var maxH = Globals._wsMgr.GetCanvasHeight();
      hSize = hSize > maxW ? maxW : hSize;
      vSize = vSize > maxH ? maxH : vSize;
    }

    this.fWidth = hSize;
    this.fHeight = vSize;

    this.fPortWidth = hSize;
    this.fPortHeight = vSize;

    var scaledWidth = Math.round(this.fWidth * Globals._dpr * this.fScaleFactor);
    var scaledHeight = Math.round(this.fHeight * Globals._dpr * this.fScaleFactor);

    if (this.fOffscreenBuffer == null) {
      this.fOffscreenBuffer = CreateCanvas(); // document.createElement('canvas');
    }

    this.fOffscreenBuffer.width = scaledWidth;
    this.fOffscreenBuffer.height = scaledHeight;
    this.fOffscreenBuffer.style.width = hSize + "px"; // keep
    this.fOffscreenBuffer.style.height = vSize + "px"; // style scale down by same scale value
    this.fForceRender = true;
  }

  //@TODO: Add params for previous pan values, to prevent snap back in content add scenarios
  SizePanelAndPort(hSize, vSize, hPort, vPort) {
    //canvas size threshold to prevent render lock
    this.fDisableHiResScaling = false;
    var sizeScale = this.fScaleFactor * Globals._dpr;
    var scaledWidth = Math.round(hSize * sizeScale);
    var scaledHeight = Math.round(vSize * sizeScale);

    // Drop hi-res scaling once either axis passes the comfortable buffer size. Taking
    // the zoom factor out of the multiplication only shrinks the buffer when zoomed IN
    // (fScaleFactor > 1). Zoomed out it makes the buffer *larger*, which is how a
    // wide chart could get inflated past what the browser will draw, so only accept
    // the alternative when it is genuinely smaller.
    if (scaledWidth > kMaxCanvasPanelSize || scaledHeight > kMaxCanvasPanelSize) {
      var flatWidth = Math.round(hSize * Globals._dpr);
      var flatHeight = Math.round(vSize * Globals._dpr);
      if (flatWidth * flatHeight < scaledWidth * scaledHeight) {
        scaledWidth = flatWidth;
        scaledHeight = flatHeight;
        this.fDisableHiResScaling = true;
      }
    }

    // Beyond kMaxCanvasDrawableSize on either axis the browser accepts the canvas and
    // then throws away everything drawn into it, so the page cannot be shown at all.
    // Clamp to keep a live canvas and flag it; QCanvasPanel.SwitchToSubChart turns the
    // flag into a message rather than leaving the user a blank chart.
    //
    // Deliberately a per-axis test with no area component: an area cap rejects pages
    // that draw perfectly well (16384x16384 = 268M px is fine), which is a false
    // refusal the user sees for no reason.
    this.fCanvasSizeExceeded =
      scaledWidth > kMaxCanvasDrawableSize || scaledHeight > kMaxCanvasDrawableSize;

    if (this.fCanvasSizeExceeded) {
      this.fRequestedBufferWidth = scaledWidth;
      this.fRequestedBufferHeight = scaledHeight;
      scaledWidth = Math.min(scaledWidth, kMaxCanvasDrawableSize);
      scaledHeight = Math.min(scaledHeight, kMaxCanvasDrawableSize);
    }

    this.fWidth = hSize;
    this.fHeight = vSize;
    this.fPortWidth = hPort;
    this.fPortHeight = vPort;

    if (this.fOffscreenBuffer == null) {
      this.fOffscreenBuffer = CreateCanvas(); // document.createElement('canvas');
    }

    this.fOffscreenBuffer.width = scaledWidth;
    this.fOffscreenBuffer.height = scaledHeight;
    this.fOffscreenBuffer.style.width = hSize + "px"; // keep
    this.fOffscreenBuffer.style.height = vSize + "px"; // style scale down by same scale value

    var panX = this.fPanX;
    var panY = this.fPanY;

    this.PanPanel(panX, panY, 0, 0);

    this.fForceRender = true;
  }

  IsShown() {
    return this.fShown && this.fRenderPhoenix;
  }

  SetShownState(showPanel) {
    this.fShown = showPanel;
    if (this.fPanelCollection) this.fPanelCollection.SetShownState(showPanel);
  }

  // Panning
  SetPanX(x) {
    this.fPanX = Math.round(x);
    if (this.fBackgroundPanel != null) {
      if (this.fBackgroundPanel.GetHasHorzScrollBar() && this.fBackgroundPanel.fScrollBarH)
        this.fBackgroundPanel.fScrollBarH.UpdateScrollBar();
    }
  }

  SetPanY(y) {
    this.fPanY = Math.round(y);
    if (this.fBackgroundPanel != null) {
      if (this.fBackgroundPanel.GetHasVertScrollBar() && this.fBackgroundPanel.fScrollBarV)
        this.fBackgroundPanel.fScrollBarV.UpdateScrollBar();
    }
  }

  GetPanX() {
    return this.fPanX;
  }

  GetPanY() {
    return this.fPanY;
  }

  SetHideScrollBar(hide) {
    this.fHideScrollBar = hide;
  }

  GetHideScrollBar() {
    return this.fHideScrollBar;
  }

  SetAllowPanOnElemHit(allowPanHit) {
    this.fAllowPanOnElemHit = allowPanHit;
  }

  GetAllowPanelPanOnElemHit() {
    return this.fAllowPanOnElemHit;
  }

  SetPanelPanHideScrollBarMode() {
    this.SetPanelMode(enumPanelMode.combinedMode);
    this.SetHideScrollBar(true);
    this.SetAllowPanOnElemHit(true);
  }

  GetPanelMode() {
    return this.fPanelMode;
  }

  SetPanelMode(panelMode) {
    this.fPanelMode = panelMode;
  }

  PanPanel(origPanX, origPanY, deltaX, deltaY) {
    var newPanX = origPanX - Math.round(deltaX / this.fScaleFactor);
    var newPanY = origPanY - Math.round(deltaY / this.fScaleFactor);

    var srcWidth = this.GetPortWidth() / this.fScaleFactor;
    var srcHeight = this.GetPortHeight() / this.fScaleFactor;

    var width = this.GetWidth();
    var height = this.GetHeight();

    if (newPanX + srcWidth > width) newPanX = width - srcWidth;

    if (newPanY + srcHeight > height) newPanY = height - srcHeight;

    if (newPanX < 0) newPanX = 0;

    if (newPanY < 0) newPanY = 0;

    this.SetPanX(newPanX);
    this.SetPanY(newPanY);

    if (this.fBackgroundPanel) {
      this.fBackgroundPanel.PanExtras(origPanX, origPanY, deltaX, deltaY);
      this.fBackgroundPanel.PanYAssociates(this, newPanY);
    }
  }

  // override for panning elements that need to be panned by scrollbar that doesnt live on the same panel
  PanExtras() {}

  // used for scrolling nested panel associates from a reference panel and panY value
  PanYAssociates(controlPanel, newPanY) {
    // Handle positioning of nested portPanel (Auth panel)
    if (this.fHasVertScrollBar && controlPanel) {
      var panelCollection = controlPanel.fPanelCollection;
      if (panelCollection == null) return;

      var associatePanels = panelCollection.fPanels;
      for (var i = 0; i < associatePanels.length; i++) {
        var panelAssociate = associatePanels[i];
        var parentContainer = panelAssociate.GetParentContainer();
        if (parentContainer == null) continue;
        var x = panelAssociate.GetPositionX();
        var y =
          panelAssociate.GetNestedStartYOffset() +
          parentContainer.GetPositionY() +
          (panelAssociate.fHOffset || 0);
        panelAssociate.PositionPanel(x, y - newPanY);
        if (panelAssociate.fPanelCollection && panelAssociate.fPanelCollection.fPanels.length > 0) {
          this.PanYAssociates(panelAssociate, newPanY);
        }
      }
    }
  }

  GetLocalX(x) {
    var xLocal = (x - this.fHorzOffset) / this.fScaleFactor + this.GetPanX();
    xLocal = Math.round(xLocal);

    return xLocal;
  }

  GetLocalY(y) {
    var yLocal = (y - this.fVertOffset) / this.fScaleFactor + this.GetPanY();
    yLocal = Math.round(yLocal);

    return yLocal;
  }

  SetLastClick(x, y, globalToLocal) {
    if (globalToLocal) {
      this.fClickX = this.GetLocalX(x);
      this.fClickY = this.GetLocalY(y);
    } else {
      this.fClickX = x;
      this.fClickY = y;
    }
  }

  GetLastClickX() {
    return this.fClickX;
  }

  GetLastClickY() {
    return this.fClickY;
  }

  GetElementRect(theElement) {
    var borderStyle = theElement.GetBorderStyle();
    var borderWidth = theElement.GetBorderWidth(borderStyle);

    var xLocal = theElement.GetPositionX() - borderWidth; // this.GetLocalX(theElement.GetPositionX());
    var yLocal = theElement.GetPositionY() - borderWidth; // this.GetLocalY(theElement.GetPositionY());
    var elementWidth = theElement.GetWidth() + 2 * borderWidth;
    var elementHeight = theElement.GetHeight() + 2 * borderWidth;

    var rect = new QRect();
    rect.fLeft = xLocal;
    rect.fTop = yLocal;
    rect.fRight = xLocal + elementWidth;
    rect.fBottom = yLocal + elementHeight;

    return rect;
  }

  GetElementPositionX(theElement) {
    // Hmmm do we need to worry about scaling here?
    var xLocal = this.fHorzOffset + theElement.GetPositionX();
    return xLocal;
  }

  GetElementPositionY(theElement) {
    var yLocal = this.fVertOffset + theElement.GetPositionY();
    if (this.fPanY) yLocal -= this.fPanY;
    return yLocal;
  }

  GetSelectedElementsBoundingRect() {
    var theRect;
    var unionRect = null;

    var s = this.GetSelectionCache();
    var numElements = s.length;
    for (var i = 0; i < numElements; i++) {
      var theElement = s[i];
      theRect = this.GetElementRect(theElement);
      if (unionRect == null) unionRect = theRect;
      else unionRect.UnionRect(theRect);
    }

    return unionRect;
  }

  MoveSelectedElements(deltaX, deltaY) {
    var s = this.GetSelectionCache();
    var numElements = s.length;

    deltaX = Math.round(deltaX / this.fScaleFactor);
    deltaY = Math.round(deltaY / this.fScaleFactor);

    for (var i = 0; i < numElements; i++) {
      var theElement = s[i];
      theElement.MoveElement(deltaX, deltaY);
    }
  }

  MoveDropIndicator() {
    // update drop indicator
  }

  MoveElement(theElement, deltaX, deltaY) {
    deltaX = deltaX / this.fScaleFactor;
    deltaY = deltaY / this.fScaleFactor;
    deltaX = Math.round(deltaX);
    deltaY = Math.round(deltaY);

    theElement.MoveElement(deltaX, deltaY);
  }

  // Drag & drop
  IsDraggable() {
    return this.fDragable;
  }

  SetDraggable(dragable) {
    this.fDragable = dragable;
  }

  StartControlInteract(theElement, x, y, shiftDown) {
    var xPanel = this.GetLocalX(x);
    var yPanel = this.GetLocalY(y);
    //xPanel = Math.round(xPanel);
    //yPanel = Math.round(yPanel);

    return theElement.StartInteractWithElement(x, y, xPanel, yPanel, shiftDown);
  }

  InitializeDragPanel(wsMgr, sourceElement, canvasX, canvasY, shiftDown) {
    var dragReady = sourceElement.IsDragReady();
    if (!dragReady) return null;

    if (!shiftDown && !wsMgr.CtrlDown()) this.ClearSelection();

    var elemDragInfo = sourceElement.GetElementDragInfo();

    var srcPanel = elemDragInfo.GetSourcePanel();
    var dstPanel = elemDragInfo.GetDestinationPanel();
    var releaseCmd = elemDragInfo.GetReleaseCmd();
    var allowedTargets = elemDragInfo.GetAllowedTargets();
    var startCmd = elemDragInfo.GetStartCmd();
    var hideValidTargetIndicator = elemDragInfo.GetHideTargetIndicator();
    var elemDragPanel = sourceElement.GetDragPanelClass();
    elemDragPanel.InitElementDragPanel(
      wsMgr,
      sourceElement,
      canvasX,
      canvasY,
      srcPanel,
      dstPanel,
      releaseCmd,
      shiftDown,
      startCmd,
      hideValidTargetIndicator
    );
    elemDragPanel.SetShownState(false);
    elemDragPanel.SetAllowedTargets(allowedTargets);
    elemDragPanel.fIsDynamicTarget = elemDragInfo.fIsDynamicTarget;

    return elemDragPanel;
  }

  SetDragReferences() {
    // override this
  }

  PrepInteractWithElement(theElement, x, y) {
    // Override this
  }

  InteractWithElement(theElement, x, y) {
    var xLocal = this.GetLocalX(x);
    var yLocal = this.GetLocalY(y);

    //xLocal = Math.round(xLocal);
    //yLocal = Math.round(yLocal);

    this.PrepInteractWithElement(theElement, x, y);
    theElement.InteractWithElement(xLocal, yLocal);
  }

  //======================================================================================================================
  // drag and drop upload
  SetDropInfo(
    canUpload,
    directory,
    restrictions,
    targetPanel,
    targetElem,
    postUploadCallback,
    alertSuccess = true,
    locateHitElement = false
  ) {
    this.fDropInfo["dropEnabled"] = canUpload; // turn on/off functionality (bool)
    this.fDropInfo["dropDirectory"] = directory; // target upload directory (string)
    this.fDropInfo["dropRestrictions"] = restrictions; // file extensions permitted (array)
    this.fDropInfo["targetPanel"] = targetPanel; // leave this null/undefined unless required to reset target panel for upload (usually parent)
    this.fDropInfo["alertSuccess"] = alertSuccess;
    this.fDropInfo["locateHitElement"] = locateHitElement;
  }

  GetDropEnabled() {
    return this.fDropInfo["dropEnabled"];
  }

  GetDropInfo() {
    return this.fDropInfo;
  }

  HandlePostDropUpload(fileInfo) {
    // override this for updating panel after successful upload
  }

  DoHoverBox() {
    var width = this.fPortPanel ? this.GetDisplayPortMaxWidth() : this.GetWidth();
    var height = this.fPortPanel ? this.GetDisplayPortMaxHeight() : this.GetHeight();
    var posX = 5;
    var posY = 5;
    var targetPanel = this;
    if (this.fPortPanel) targetPanel = this.fPortPanel;
    if (this.fHoverBox) {
      targetPanel.RemoveElement(this.fHoverBox);
    }
    this.fHoverBox = this.AddHoverBox(targetPanel, posX, posY, width, height);
  }

  HideHoverBox() {
    if (this.fHoverBox) {
      this.fHoverBox.SetShownState(false);
    }
  }

  // DoWaiting(msg, addCancel) {
  //   this.fWaiting = new QWaitingPanel();
  //   this.fWaiting.SetMsgColor(uFramelessPanelColor);
  //   this.fWaiting.InitWaitingPanel(msg, this.fWSMgr.fBackgroundPanel, this.fWSMgr, 220);
  //   ReportToWebDriver(msg);
  //   if (addCancel) this.fWaiting.AddCancel(this);
  //   this.fWSMgr.fWaiting = this.fWaiting;
  // }

  DoInteractWithElement() {}

  //======================================================================================================================
  PushElement(anElement) {
    if (this.fElements == null) this.fElements = [];
    this.fElements.push(anElement);

    if (this.fZPlanes == null) {
      //this is v. bad. We do NOT want this to be happening.
      this.fZPlanes = [];
    }
    var theZPlane = anElement.GetZPlane();
    if (theZPlane > this.fZPlanes.length - 1) {
      this.AddZPlane(theZPlane);
    }
    this.fZPlanes[theZPlane].push(anElement);
    if (this.fZPlanes[theZPlane].length != this.fElements.length && this.fZPlanes.length == 1) {
      console.log("Our plane and element lengths mismatch");
    }
    anElement.SetParentPanelRef(this);
  }

  AddToTabList(anElement, theID) {
    if (this.fTabList == null) this.fTabList = [];
    this.fTabList.push(anElement);
  }

  RemoveFromTabList(anElement) {
    if (this.fTabList == null) return;

    var index = this.fTabList.indexOf(anElement);
    if (index != -1) this.fTabList.splice(index, 1);
  }

  TabToNextElement(forward, targetElement, wsMgr) {
    PTabToNextElement(targetElement, this, forward, this.fTabList, wsMgr);
  }

  PanToNextElement(nextElement, top) {
    if (this.fPortPanel == null) return;
    var elemBuffer = 2;
    var portPanel = this.fPortPanel;

    var delta = top ? nextElement.GetHeight() + elemBuffer : portPanel.fPortHeight;

    if (nextElement.fVertOffset > portPanel.fPanY + portPanel.fPortHeight)
      portPanel.SetPanY(nextElement.fVertOffset - delta + nextElement.GetHeight() + elemBuffer);
    else if (
      nextElement.fVertOffset > portPanel.fPortHeight &&
      nextElement.fVertOffset < portPanel.fPanY + portPanel.fPortHeight
    )
      portPanel.SetPanY(nextElement.fVertOffset - delta + nextElement.GetHeight() + elemBuffer);
    else {
      portPanel.SetPanY(0);
    }
  }

  GetFirstAvailableTextEdit(tabList, curIdx, curTabID, n, shiftOff) {
    var adder = shiftOff ? 1 : -1;
    var done = false;
    while (!done) {
      var nextElement = tabList[curIdx];
      var nextTabID = nextElement.GetTabID();
      if (
        (shiftOff && nextTabID <= curTabID) ||
        (!shiftOff && nextTabID >= curTabID) ||
        !nextElement.IsEnabled() ||
        !nextElement.IsShown()
      ) {
        curIdx = curIdx + adder;
      }

      if (curIdx >= n) curIdx = 0;
      if (curIdx < 0) curIdx = n - 1;

      nextElement = tabList[curIdx];
      done = nextElement.IsEnabled() && nextElement.IsShown();
    }
    return nextElement;
  }

  ClipToBoundsX(x, elementLeft, elementRight, startX) {
    /*
	var margins = this.GetMargins();

	var leftBound = this.fHorzOffset + (margins.fLeft* this.fScaleFactor) - this.fPanX;
	var rightBound = leftBound + (this.fWidth - margins.fLeft - margins.fRight) * this.fScaleFactor;
	var deltaLeft = leftBound + (startX - elementLeft);
	var deltaRight = rightBound - (elementRight - startX);
	*/

    var leftBound = this.fHorzOffset - this.fPanX;
    var rightBound = leftBound + this.fWidth * this.fScaleFactor;
    var deltaLeft = leftBound + (startX - elementLeft);
    var deltaRight = rightBound - (elementRight - startX);

    if (x < deltaLeft) {
      x = deltaLeft;
    } else if (x > deltaRight) {
      x = deltaRight;
    }

    return x;
  }

  ClipToBoundsY(y, elementTop, elementBottom, startY) {
    /*
	 var margins = this.GetMargins();

	var topBound = this.fVertOffset + (margins.fTop* this.fScaleFactor) - this.fPanY;
	var bottomBound = topBound + (this.fHeight - margins.fTop - margins.fBottom) * this.fScaleFactor;
	var deltaTop = topBound + (startY - elementTop);
	var deltaBottom = bottomBound - (elementBottom - startY);
	*/
    var topBound = this.fVertOffset - this.fPanY;
    var bottomBound = topBound + this.fHeight * this.fScaleFactor;
    var deltaTop = topBound + (startY - elementTop);
    var deltaBottom = bottomBound - (elementBottom - startY);

    if (y < deltaTop) {
      y = deltaTop;
    } else if (y > deltaBottom) {
      y = deltaBottom;
    }

    return y;
  }

  TestForActive(targetElement, x, y, elementType, panelHitTest) {
    var elementGroup = targetElement.GetElementGroup();
    if (elementGroup != null) {
      var activeElement = elementGroup["ActiveElement"];
      if (activeElement == targetElement) return targetElement;

      if (activeElement) {
        var proceed = true;
        if (elementType != null) proceed = activeElement.GetElementType() == elementType;

        if (proceed) {
          activeElement = activeElement.HitTest(x, y, panelHitTest);
          if (activeElement != null) targetElement = activeElement;
        }
      }
    }

    return targetElement;
  }

  HitTest(x, y, elementType) {
    var panelHitTest = new QPanelHitTest();
    var portWidth = this.GetActualPortWidth(); // need to compare against where dom thinks element is
    var portHeight = this.GetActualPortHeight();
    var panelX = this.GetActualPositionX();
    var panelY = this.GetActualPositionY();

    if (this.fClippedRegionCoords) {
      var clippedX = this.fClippedRegionCoords.sx;
      var clippedY = this.fClippedRegionCoords.sy;

      portHeight += panelY - clippedY;
      portWidth += panelX - clippedX;

      panelY = clippedY;
      panelX = clippedX;
    }

    if (
      x * Globals._dpr >= panelX &&
      x * Globals._dpr <= panelX + portWidth &&
      y * Globals._dpr >= panelY &&
      y * Globals._dpr <= panelY + portHeight
    ) {
      panelHitTest.fPanelHit = this;
      var xLocal = this.GetLocalX(x);
      var yLocal = this.GetLocalY(y);
      if (this.fZPlanes == null) console.log("BAD");
      for (var aZPlaneIdx = this.fZPlanes.length - 1; aZPlaneIdx > -1; aZPlaneIdx--) {
        for (
          var anElementIdx = this.fZPlanes[aZPlaneIdx].length - 1;
          anElementIdx > -1;
          anElementIdx--
        ) {
          panelHitTest.fElementHit = null;
          var theElement = this.fZPlanes[aZPlaneIdx][anElementIdx];
          if (theElement.IsShown() && this.IsElementActive(theElement, true)) {
            var dragInProgress = this.fWSMgr.fInteractMode === enumWSInteractMode.elementDragMode;
            var elemBusy =
              this.fWSMgr &&
              this.fWSMgr.fTargetElement != null &&
              dragInProgress &&
              this.fWSMgr.fTargetElement == theElement;
            var validElement =
              !(elementType != null && elementType !== theElement.GetElementType()) && !elemBusy;
            if (validElement) {
              theElement.HitTest(xLocal, yLocal, panelHitTest);
              /*
						if (theElement.IsEnabled())
							theElement.HitTest(xLocal,yLocal,panelHitTest);
						else if (panelHitTest.fDisabledElementHit == null)
						{
							panelHitTest.fDisabledElementHit = theElement.HitTest(xLocal,yLocal,panelHitTest);
						}

						 */
            }
          }
          //|| panelHitTest.fDisabledElementHit != null	//not sure what is going on here
          if (panelHitTest.fElementHit != null) {
            //What is this?
            //panelHitTest.fElementHit = this.TestForActive(panelHitTest.fElementHit,xLocal,yLocal,elementType, panelHitTest);
            return panelHitTest;
          }
        }
      }
    }

    return panelHitTest;
  }

  DoRenderBackground(drawBuffer) {
    // Override this
  }

  DoGetGradientVals() {
    var p = new QPoint();
    p.InitPoint(this.fFillGradientStart, this.fFillGradientEnd); //, this.fFillMiddleColor);
    return p;
  }

  GetGradient(ctx) {
    var createGradient = this.fGradient == null || this.fForceRender;
    if (createGradient) {
      /*
		var fillMode = this.GetFillMode();
		var targetGradient = fillMode === enumFillMode.linearGradientDown ? ctx.createLinearGradient(0,0,0,this.fHeight) : ctx.createLinearGradient(0,0,this.fWidth,0);
		var p = this.DoGetGradientVals();
		targetGradient.addColorStop(0,p.fX);
		if (p.fZ)
	 		targetGradient.addColorStop(0.5,p.fZ);
	 	targetGradient.addColorStop(1,p.fY);
		*/
      var gradient = ctx.createLinearGradient(0, 0, 0, this.fHeight); // this.fHeight
      var p = this.DoGetGradientVals();
      gradient.addColorStop(0, p.fX);
      gradient.addColorStop(1, p.fY);

      //gradient.addColorStop(0,this.fFillGradientStart);
      //gradient.addColorStop(1,this.fFillGradientEnd);

      this.fGradient = gradient;
    }

    return this.fGradient;
  }

  RenderBackground() {
    var fillMode = this.GetFillMode();
    var ctx = this.fOffscreenBuffer.getContext("2d");
    if (fillMode === enumFillMode.solidFill) ctx.fillStyle = this.GetFillColor();
    else if (fillMode === enumFillMode.linearGradientDown) ctx.fillStyle = this.GetGradient(ctx);

    var width = this.fOffscreenBuffer.width;
    var height = this.fOffscreenBuffer.height;
    if (fillMode !== enumFillMode.noFill) {
      if (this.fAltCanvas != null) {
        ctx.fillRect(0, 0, width, height);
      } else {
        var src = this.GetBufferSourceRect();
        // Expand by a pixel so no seam shows at the edges of the blit.
        var bx = Math.max(0, Math.floor(src.fLeft) - 1);
        var by = Math.max(0, Math.floor(src.fTop) - 1);
        var bw = Math.min(width - bx, Math.ceil(src.fWidth) + 2);
        var bh = Math.min(height - by, Math.ceil(src.fHeight) + 2);
        if (bw > 0 && bh > 0) ctx.fillRect(bx, by, bw, bh);
      }
    }

    this.DoRenderBackground(this.fOffscreenBuffer);
  }

  RenderShadowAndBorder(drawBuffer) {
    var borderStyle = this.GetBorderStyle();
    var borderThickness = this.GetBorderThickness();
    var borderWidth = 0;
    var portWidth = Math.round(this.GetActualPortWidth());
    var portHeight = Math.round(this.GetActualPortHeight());

    if (borderStyle === enumPanelBorderStyle.noBorder) borderWidth = 0;
    else {
      if (
        borderStyle === enumPanelBorderStyle.singleBorder ||
        borderStyle === enumPanelBorderStyle.framelessBorder ||
        enumPanelBorderStyle.roundBorder
      )
        borderWidth = borderThickness / 2;
      else borderWidth = borderThickness + 2 + borderThickness / 2;
    }
    var borderPlacement = borderThickness / 2;
    if (this.GetShadowOn()) {
      drawBuffer.save();
      drawBuffer.fillStyle = "rgba(255, 255, 255, 1)";
      drawBuffer.shadowOffsetX = 0;
      drawBuffer.shadowOffsetY = 1 + borderPlacement;
      drawBuffer.shadowBlur = 8;
      drawBuffer.shadowColor = "rgba(120, 120, 120, 1.0)";
      drawBuffer.shadowInset = true;

      var shadowBoxLeft = Math.round(this.GetActualPositionX()) + borderPlacement;
      var shadowBoxTop = Math.round(this.GetActualPositionY()) + borderPlacement;
      var shadowBoxWidth = portWidth;
      var shadowBoxHeight = portHeight;

      if (borderStyle === enumPanelBorderStyle.roundBorder) {
        drawBuffer.lineJoin = "round";
        drawBuffer.lineWidth = 1;
        var sx = shadowBoxLeft + borderPlacement;
        var sy = shadowBoxTop + borderPlacement;
        var x0 = sx;
        var y0 = sy;
        var x1 = shadowBoxLeft + shadowBoxWidth - borderPlacement;
        var y1 = shadowBoxTop + shadowBoxHeight - borderPlacement;

        var r = this.fBorderRadius;

        var w = x1 - x0;
        var h = y1 - y0;
        if (r > w / 2) r = w / 2;
        if (r > h / 2) r = h / 2;

        drawBuffer.beginPath();
        drawBuffer.moveTo(x1 - r, y0);
        drawBuffer.quadraticCurveTo(x1, y0, x1, y0 + r);
        drawBuffer.lineTo(x1, y1 - r);
        drawBuffer.quadraticCurveTo(x1, y1, x1 - r, y1);
        drawBuffer.lineTo(x0 + r, y1);
        drawBuffer.quadraticCurveTo(x0, y1, x0, y1 - r);
        drawBuffer.lineTo(x0, y0 + r);
        drawBuffer.quadraticCurveTo(x0, y0, x0 + r, y0);
        drawBuffer.closePath();
        drawBuffer.fill();
        //drawBuffer.fillRect(shadowBoxLeft+radius/2,shadowBoxTop+radius,shadowBoxWidth-radius, shadowBoxHeight-radius);
      } else drawBuffer.fillRect(shadowBoxLeft, shadowBoxTop, shadowBoxWidth, shadowBoxHeight);

      drawBuffer.restore();
    }

    if (borderStyle == enumPanelBorderStyle.noBorder) return;

    var borderColor = this.GetBorderColor();

    drawBuffer.save();
    drawBuffer.strokeStyle = borderColor;
    drawBuffer.lineWidth = borderThickness;

    var borderBoxLeft = Math.round(this.GetActualPositionX()) - borderPlacement;
    var borderBoxTop = Math.round(this.GetActualPositionY()) - borderPlacement;
    var borderBoxWidth = portWidth + borderPlacement * 2;
    var borderBoxHeight = portHeight + borderPlacement * 2;
    if (
      borderStyle === enumPanelBorderStyle.singleBorder ||
      borderStyle === enumPanelBorderStyle.doubleBorder
    ) {
      drawBuffer.beginPath();
      drawBuffer.moveTo(borderBoxLeft, borderBoxTop);
      drawBuffer.lineTo(borderBoxLeft + borderBoxWidth, borderBoxTop);
      drawBuffer.lineTo(borderBoxLeft + borderBoxWidth, borderBoxTop + borderBoxHeight);
      drawBuffer.lineTo(borderBoxLeft, borderBoxTop + borderBoxHeight);
      drawBuffer.lineTo(borderBoxLeft, borderBoxTop);
      drawBuffer.closePath();
      drawBuffer.stroke();
    }
    if (borderStyle == enumPanelBorderStyle.doubleBorder) {
      borderPlacement = borderThickness + 2 + borderThickness / 2;
      var borderBoxLeft = Math.round(this.GetActualPositionX()) - borderWidth;
      var borderBoxTop = Math.round(this.GetActualPositionY()) - borderWidth;
      var borderBoxWidth = portWidth + borderWidth * 2;
      var borderBoxHeight = portHeight + borderWidth * 2;

      drawBuffer.beginPath();
      drawBuffer.moveTo(borderBoxLeft, borderBoxTop);
      drawBuffer.lineTo(borderBoxLeft + borderBoxWidth, borderBoxTop);
      drawBuffer.lineTo(borderBoxLeft + borderBoxWidth, borderBoxTop + borderBoxHeight);
      drawBuffer.lineTo(borderBoxLeft, borderBoxTop + borderBoxHeight);
      drawBuffer.lineTo(borderBoxLeft, borderBoxTop);
      drawBuffer.closePath();
      drawBuffer.stroke();
    }
    if (borderStyle === enumPanelBorderStyle.framelessBorder) {
      //Top Line
      drawBuffer.strokeStyle = uFramelessPanelColorLighter;
      drawBuffer.beginPath();
      drawBuffer.moveTo(borderBoxLeft - 1, borderBoxTop);
      drawBuffer.lineTo(borderBoxLeft + borderBoxWidth + 1, borderBoxTop);
      drawBuffer.closePath();
      drawBuffer.stroke();
      //Right Line
      drawBuffer.strokeStyle = uFramelessPanelColorDarker;
      drawBuffer.beginPath();
      drawBuffer.moveTo(borderBoxLeft + borderBoxWidth, borderBoxTop + borderWidth);
      drawBuffer.lineTo(borderBoxLeft + borderBoxWidth, borderBoxTop + borderBoxHeight + 1);
      drawBuffer.closePath();
      drawBuffer.stroke();
      //Bottom LIne
      drawBuffer.strokeStyle = uFramelessPanelColorDarker;
      drawBuffer.beginPath();
      drawBuffer.moveTo(borderBoxLeft + borderBoxWidth, borderBoxTop + borderBoxHeight);
      drawBuffer.lineTo(borderBoxLeft, borderBoxTop + borderBoxHeight);
      drawBuffer.closePath();
      drawBuffer.stroke();
      //Left Line
      drawBuffer.strokeStyle = uFramelessPanelColorLighter;
      drawBuffer.beginPath();
      drawBuffer.moveTo(borderBoxLeft, borderBoxTop + borderBoxHeight + 1);
      drawBuffer.lineTo(borderBoxLeft, borderBoxTop);
      drawBuffer.closePath();
      drawBuffer.stroke();
    }
    if (borderStyle === enumPanelBorderStyle.roundBorder) {
      var sx = borderBoxLeft;
      var sy = borderBoxTop;
      var x0 = sx + borderPlacement;
      var y0 = sy + borderPlacement;
      var x1 = borderBoxLeft + borderBoxWidth - borderPlacement;
      var y1 = borderBoxTop + borderBoxHeight - borderPlacement;

      var r = this.fBorderRadius;

      var w = x1 - x0;
      var h = y1 - y0;
      if (r > w / 2) r = w / 2;
      if (r > h / 2) r = h / 2;

      var clippedRegion = new Path2D();
      //clippedRegion.beginPath();
      clippedRegion.moveTo(x1 - r, y0);
      clippedRegion.quadraticCurveTo(x1, y0, x1, y0 + r);
      clippedRegion.lineTo(x1, y1 - r);
      clippedRegion.quadraticCurveTo(x1, y1, x1 - r, y1);
      clippedRegion.lineTo(x0 + r, y1);
      clippedRegion.quadraticCurveTo(x0, y1, x0, y1 - r);
      clippedRegion.lineTo(x0, y0 + r);
      clippedRegion.quadraticCurveTo(x0, y0, x0 + r, y0);
      clippedRegion.closePath();
      if (borderWidth >= 1) {
        drawBuffer.stroke(clippedRegion);
      }

      this.fClippedRegion = clippedRegion;
    }

    //TODO clipping panel regions out of  parent container bounds should not be a border style!

    if (borderStyle === enumPanelBorderStyle.dynamicClipBorder) {
      var containerPanel = this.GetParentContainer();
      if (containerPanel == null) {
        containerPanel = this.fBackgroundPanel;
      }

      var topY = containerPanel.GetActualPositionY();
      var backgroundLowerY = Math.round(topY + containerPanel.GetActualPortHeight());
      var panelLowerY = Math.round(this.GetActualPortHeight() + this.GetActualPositionY());

      var difference = 0;
      if (borderBoxTop <= topY) {
        difference = topY - borderBoxTop;
        if (difference < borderBoxHeight) borderBoxHeight -= difference;
        borderBoxTop = topY;
      }
      if (panelLowerY > backgroundLowerY) {
        difference = Math.abs(backgroundLowerY - panelLowerY);
        if (difference < borderBoxHeight) borderBoxHeight -= difference;
        else borderBoxHeight = 0;

        if (borderBoxHeight < 0) borderBoxHeight = 0;
      }

      this.SetClippingRegion(
        borderBoxLeft,
        borderBoxTop,
        borderBoxLeft + borderBoxWidth,
        borderBoxTop + borderBoxHeight
      );
    }
    drawBuffer.restore();
  }

  SetClippingRegion(sx, sy, ex, ey) {
    this.fClippedRegion = CreatePath2D(sx, sy, ex, ey);
    this.fClippedRegionCoords = { sx: sx, sy: sy, ex: ex, ey: ey };
  }

  GetNumElements() {
    var numElements = 0;
    if (this.fElements != null) numElements = this.fElements.length;

    return numElements;
  }

  IsElementActive(theElement, renderOverrideHit) {
    if (theElement == null) return false;

    var eLayer = theElement.GetLayer();
    var renderMode = this.GetRenderMode();
    var isActive;

    switch (renderMode) {
      case enumPanelRenderMode.all:
        isActive = eLayer == enumElementLayer.content;
        if (!isActive && eLayer == enumElementLayer.master && renderOverrideHit)
          isActive = theElement.HasActiveSubs();
        break;
      case enumPanelRenderMode.contentOnly:
        isActive = eLayer == enumElementLayer.content;
        break;
      case enumPanelRenderMode.backgroundAndGhostChart:
      case enumPanelRenderMode.masterOnly:
        isActive = eLayer == enumElementLayer.master;
        break;
    }

    return isActive;
  }

  IsElementInLayer(theElement) {
    var eLayer = theElement.GetLayer();
    var renderMode = this.GetRenderMode();
    var isActive;

    switch (renderMode) {
      case enumPanelRenderMode.backgroundAndGhostChart:
      case enumPanelRenderMode.all:
        isActive = true;
        break;
      case enumPanelRenderMode.masterOnly:
        isActive = eLayer == enumElementLayer.master;
        break;
      case enumPanelRenderMode.contentOnly:
        //Replacement to prior system used to produce master pages without their elements.
        isActive = eLayer !== enumElementLayer.master || theElement.OverrideHideMaster();
        break;
    }

    return isActive;
  }

  // Mirrors the viewport math in ElementInViewPort/DoRenderElements
  // so full-chart painters can restrict themselves to what is actually
  // on screen
  GetVisibleRect() {
    var zoom = this.GetScaleFactor();
    var left = this.GetPanX();
    var top = this.GetPanY();

    return {
      fLeft: left,
      fTop: top,
      fRight: left + this.GetPortWidth() / zoom,
      fBottom: top + this.GetPortHeight() / zoom
    };
  }

  // The offscreen buffer is sized to the whole chart extent, so this is t
  // he only part worth painting on any given frame.
  GetBufferSourceRect() {
    var dpr = Globals._dpr;
    var left = this.fPanX * dpr * this.fScaleFactor;
    var top = this.fPanY * dpr * this.fScaleFactor;
    var width = Math.round(this.fPortWidth * dpr);
    var height = Math.round(this.fPortHeight * dpr);

    if (this.fDisableHiResScaling) {
      left = this.fPanX * dpr;
      top = this.fPanY * dpr;
      width = Math.round((this.fPortWidth * dpr) / this.fScaleFactor);
      height = Math.round((this.fPortHeight * dpr) / this.fScaleFactor);
    }

    return { fLeft: left, fTop: top, fWidth: width, fHeight: height };
  }

  ElementInViewPort(element, considerSize) {
    var dpr = Globals._dpr;
    var posX = element.GetPositionX() * dpr;
    var posY = element.GetPositionY() * dpr;
    var endX = posX + element.GetWidth() * dpr;
    var endY = posY + element.GetHeight() * dpr;

    // Use cached viewport bounds from DoRenderElements when available (render path),
    // otherwise compute on the fly (search focus path)
    var vpLeft, vpTop, vpRight, vpBottom;
    if (this._vpLeft !== undefined) {
      vpLeft = this._vpLeft;
      vpTop = this._vpTop;
      vpRight = this._vpRight;
      vpBottom = this._vpBottom;
    } else {
      var zoom = this.GetScaleFactor();
      vpLeft = this.fPanX * dpr;
      vpTop = this.fPanY * dpr;
      vpRight = vpLeft + (this.GetPortWidth() * dpr) / zoom;
      vpBottom = vpTop + (this.GetPortHeight() * dpr) / zoom;
    }

    if (considerSize) {
      // Check if the entire element is fully visible in the viewport (less strict used by search focus)
      return posX >= vpLeft && endX <= vpRight && posY >= vpTop && endY <= vpBottom;
    } else {
      // Check if any part of the element is within the viewport (more strict, used by render tree)
      return posX < vpRight && endX > vpLeft && posY < vpBottom && endY > vpTop;
    }
  }

  DoIncludeElementInSelection(theElement) {
    return true; // Override
  }

  IncludeElementInSelection(theElement) {
    var isSelectable = theElement.IsSelectable() && this.IsElementActive(theElement);
    if (isSelectable) isSelectable = this.DoIncludeElementInSelection(theElement);
    return isSelectable;
  }

  PerformSelect(theElement, selectIt) {
    theElement.SetSelected(selectIt);
  }

  DoCloseElement(theElement) {
    var ZIndex = this.fZPlanes[theElement.fZPlane].indexOf(theElement);
    if (ZIndex != -1) {
      this.fZPlanes[theElement.fZPlane].splice(ZIndex, 1);
    } else {
      console.log("CRITICAL FAILURE to remove element from ZPlane.");
    }
    if (theElement == null) console.log("DoCloseElement");
    theElement.CloseElement();
    theElement.SetElementGroup(null);
    this.RemoveFromTabList(theElement);
    this.RemoveFromSelectionCache(theElement);
  }

  DoSelectElement(theElement, selectIt) {
    if (selectIt) this.AddToSelectionCache(theElement);
    else this.RemoveFromSelectionCache(theElement);
    this.PerformSelect(theElement, selectIt);
  }

  CustomShiftSelect(targetElement) {
    return false;
  }

  ReacquireTarget(targetElement) {
    return null;
  }

  GetTextEditByTabID(tabID) {
    var targetTextEdit = null;
    if (this.fElements == null) {
      console.log("Unable to locate target keyboard");
      return targetTextEdit;
    }
    var textEdits = this.fElements.filter(function (item) {
      return item instanceof QTextEdit && item.GetTabID() == tabID;
    });
    if (textEdits.length === 1) targetTextEdit = textEdits[0];
    return targetTextEdit;
  }

  GetAlpha() {
    return this.fAlpha;
  }

  SetAlpha(alpha) {
    this.fAlpha = alpha;
  }

  RenderAnElement(theElement) {
    var reportInfo = this.ReportRenderInfo();
    if (reportInfo) {
      console.log(
        "Rendering :" +
          theElement.ObjectName() +
          " Layer: " +
          theElement.GetLayer() +
          " ZPlane: " +
          theElement.GetZPlane()
      );
    }
    theElement.PrepRender();
    if (this.fAltCanvas != null) {
      var elementLayer = theElement.GetLayer();
      if (Globals._altLayerToRender == null || Globals._altLayerToRender == elementLayer)
        theElement.AltRender(this.fAltCanvas);
    } else theElement.RenderElement(this.fOffscreenBuffer);
  }

  GetAssociatedElements(anElement, layer) {
    return null;
    // Override this if needed. We often use this to drag linked panels together. Do not delete.
  }

  StandardRender(theElement) {
    /*
	///DEPRECATED. We don't need to use groups for rendering.
	var elementGroup = theElement.GetElementGroup();
	if (elementGroup && false)
		this.RenderGroup(elementGroup);
	else
	*/
    this.RenderAnElement(theElement);
  }

  DoRenderElements(zPlane, layer) {
    var reportRenderInfo = this.ReportRenderInfo();
    if (reportRenderInfo)
      console.log(">>>> DoRenderElements - Layer: " + layer + " ZPlane: " + zPlane);

    // Cache viewport bounds for this render pass (frame-constant values)
    var zoom = this.GetScaleFactor();
    var dpr = Globals._dpr;
    this._vpLeft = this.fPanX * dpr;
    this._vpTop = this.fPanY * dpr;
    this._vpRight = this._vpLeft + (this.GetPortWidth() * dpr) / zoom;
    this._vpBottom = this._vpTop + (this.GetPortHeight() * dpr) / zoom;

    var renderOverride = this.fAltCanvas != null; //Suppress rendering enhancement during publishing (not useful)
    for (var anElementIdx = 0; anElementIdx < zPlane.length; anElementIdx++) {
      var theElement = zPlane[anElementIdx];
      if (
        theElement.GetLayer() === layer &&
        theElement.IsShown() &&
        this.IsElementInLayer(theElement)
      ) {
        if (this.ElementInViewPort(theElement, false) || renderOverride) {
          this.RenderElementTree(theElement, new Set());
        }
      }
    }
    return true;
  }

  RenderElementTree(rootElement, renderCompletedSet) {
    // Iterative post-order traversal to avoid stack overflow on deeply nested charts.
    var stack = [{ element: rootElement, childIdx: 0 }];

    while (stack.length > 0) {
      var frame = stack[stack.length - 1];
      var el = frame.element;

      // First visit: render the element
      if (frame.childIdx === 0 && !renderCompletedSet.has(el)) {
        this.StandardRender(el);
        renderCompletedSet.add(el);
      }

      // Process next child
      var pushed = false;
      if (el.fElements != null) {
        while (frame.childIdx < el.fElements.length) {
          var subElement = el.fElements[frame.childIdx];
          frame.childIdx++;
          if (subElement.IsShown() && !renderCompletedSet.has(subElement)) {
            stack.push({ element: subElement, childIdx: 0 });
            pushed = true;
            break;
          }
        }
      }

      if (!pushed) {
        // All children done — post-render
        stack.pop();
        if (this.fAltCanvas != null) {
          var elementLayer = el.GetLayer();
          if (Globals._altLayerToRender == null || Globals._altLayerToRender == elementLayer)
            el.DoPostAltRender(this.fAltCanvas);
        } else {
          el.DoPostRender(this.fOffscreenBuffer);
        }
      }
    }
  }

  RenderAllZPlanes(layer) {
    if (!this.fZPlanes) return;
    for (var aZPlaneIdx = 0; aZPlaneIdx < this.fZPlanes.length; aZPlaneIdx++) {
      var zPlane = this.fZPlanes[aZPlaneIdx];
      this.DoRenderElements(zPlane, layer);
    }
  }

  RenderElements() {
    var scale = Globals._dpr;
    if (!this.fDisableHiResScaling) scale = Globals._dpr * this.fScaleFactor;
    var osb = this.fOffscreenBuffer.getContext("2d");
    osb.save();
    osb.scale(scale, scale);

    if (
      this.GetRenderMode() === enumPanelRenderMode.all &&
      Globals._uiConfig.GetUIMode() === enumUIModes.edit &&
      isInStandardSubmode() &&
      Globals._publishRef == null
    ) {
      osb.globalAlpha = 0.4;
    }

    this.RenderMasterPage();
    osb.globalAlpha = 1.0;

    if (this.GetRenderMode() === enumPanelRenderMode.backgroundAndGhostChart) {
      osb.globalAlpha = 0.4;
    }

    this.RenderAllZPlanes(enumElementLayer.content);
    this.RenderKeyboardFocus(osb);

    // Clear viewport cache so non-render callers (search focus) compute fresh bounds
    this._vpLeft = undefined;

    osb.restore();

    this.RenderToScreen();

    return true;
  }

  RenderMasterPage() {}

  RenderKeyboardFocus() {
    // Override this
  }

  RenderToScreen() {
    var backBuffer = this.fBackBuffer.getContext("2d");
    backBuffer.save();
    this.RenderShadowAndBorder(backBuffer);
    backBuffer.restore();
    this.DrawToBuffer(backBuffer);

    this["rstate"] = 2;

    var reportInfo = this.ReportRenderInfo();
    if (reportInfo) console.log(">>> FinishRenderPanel");
  }

  ReportRenderInfo() {
    return false;
  }

  DrawToBuffer(backBuffer) {
    // Copy the offscreen buffer to the screen
    var src = this.GetBufferSourceRect();
    var srcLeft = src.fLeft;
    var srcTop = src.fTop;
    var srcWidth = src.fWidth;
    var srcHeight = src.fHeight;

    var dstLeft = Math.round(this.fHorzOffset * Globals._dpr);
    var dstTop = Math.round(this.fVertOffset * Globals._dpr);

    var destWidth = Math.round(this.fPortWidth * Globals._dpr);
    var destHeight = Math.round(this.fPortHeight * Globals._dpr);

    var osb = this.fOffscreenBuffer;
    this.DoDrawMarquee(osb);

    if (srcWidth === 0 || srcHeight === 0 || destHeight === 0 || destWidth === 0) return;
    try {
      var copyAlpha = this.GetAlpha();
      backBuffer.globalAlpha = copyAlpha;
      backBuffer.save();
      if (this.fClippedRegion)
        // need to work on expanding this concept of clipped regions to all panel border types - currently this has issues with port panels. should clip to the base panel always
        backBuffer.clip(this.fClippedRegion);
      doDrawImage(
        backBuffer,
        osb,
        srcLeft,
        srcTop,
        srcWidth,
        srcHeight,
        dstLeft,
        dstTop,
        destWidth,
        destHeight,
        true
      );
      backBuffer.restore();
    } catch (err) {
      console.log(
        "RenderPanel - srcleft:",
        srcLeft,
        " scrtop:",
        srcTop,
        " srcWidth:",
        srcWidth,
        " srcHeight:",
        srcHeight
      );
      console.log(
        "RenderPanel - dstLeft:",
        dstLeft,
        " dstTop:",
        dstTop,
        " destWidth:",
        destWidth,
        " destHeight:",
        destHeight
      );
    }
  }

  RenderPanel() {
    var reportInfo = this.ReportRenderInfo();
    if (reportInfo) console.log(">>> Enter RenderPanel");

    this.RenderBackground();
    this.RenderElements();
  }

  BringToFront(anElement) {
    var theZLayer = anElement.fZPlane;
    var zIndex = this.fZPlanes[theZLayer].indexOf(anElement);
    if (zIndex > -1) {
      this.fZPlanes[theZLayer].splice(zIndex, 1);
      this.fZPlanes[theZLayer].push(anElement);
    }
  }

  RemoveElement(anElement) {
    var index = this.fElements.indexOf(anElement);
    if (index != -1) {
      this.DoCloseElement(anElement);
      this.fElements.splice(index, 1);
      return true;
    }

    return false;
  }

  RemoveAllElements() {
    var numElements = this.GetNumElements();
    if (numElements == 0) return;

    // Close each element (element-specific cleanup)
    for (var i = 0; i < numElements; i++) {
      var anElement = this.fElements[i];
      anElement.CloseElement();
      anElement.SetElementGroup(null);
    }

    // Clear all data structures wholesale — O(1) instead of per-element indexOf+splice
    this.fElements = [];
    this.fTabList = null;
    this.fSelectionCache = null;
    for (var z = 0; z < this.fZPlanes.length; z++) {
      if (this.fZPlanes[z]) this.fZPlanes[z] = [];
    }
  }

  BatchRemoveElements(elementsToRemove) {
    if (elementsToRemove.length === 0) return;
    var removeSet = new Set(elementsToRemove);

    // Close each removed element
    for (var i = 0; i < elementsToRemove.length; i++) {
      var theElement = elementsToRemove[i];
      theElement.CloseElement();
      theElement.SetElementGroup(null);
    }

    // Filter all data structures once — O(n) per structure
    this.fElements = this.fElements.filter(function (e) {
      return !removeSet.has(e);
    });

    for (var z = 0; z < this.fZPlanes.length; z++) {
      if (this.fZPlanes[z]) {
        this.fZPlanes[z] = this.fZPlanes[z].filter(function (e) {
          return !removeSet.has(e);
        });
      }
    }

    if (this.fTabList) {
      this.fTabList = this.fTabList.filter(function (e) {
        return !removeSet.has(e);
      });
    }

    if (this.fSelectionCache) {
      this.fSelectionCache = this.fSelectionCache.filter(function (e) {
        return !removeSet.has(e);
      });
    }
  }

  GetIndexElement(theIndex) {
    if (this.fElements == null) return null;

    return this.fElements[theIndex];
  }

  GetHasHorzScrollBar() {
    return this.fHasHorzScrollBar;
  }

  GetHasVertScrollBar() {
    return this.fHasVertScrollBar;
  }

  SetHasHorzScrollBar(scrollState) {
    this.fHasHorzScrollBar = scrollState;
  }

  SetHasVertScrollBar(scrollState) {
    this.fHasVertScrollBar = scrollState;
  }

  //=================================================================================================
  // Selection handling
  GetNumSelectedElements() {
    var selCache = this.GetSelectionCache();
    var numElements = selCache.length;
    return numElements;
  }

  GetFirstSelectedElement(elementType) {
    var selCache = this.GetSelectionCache();
    var numElements = selCache.length;
    for (var i = 0; i < numElements; i++) {
      var theElement = selCache[i];
      if (elementType == null) return theElement;
      else {
        if (theElement.GetElementType() == elementType) return theElement;
      }
    }

    /*
	var numElements = this.GetNumElements();
	for (var i=0; i < numElements; i++)
	{
		var theElement = this.fElements[i];
		if (theElement.IsSelected())
		{
			if (elementType == null)
				return theElement;
			else
			{
				if (theElement.GetElementType() == elementType)
					return theElement;
			}
		}
	}
	*/

    return null;
  }

  // Mar29
  // Get a list of all selected items - if no selected item then an empty list is returned
  GetSelectionList(elementType) {
    var theList = [];

    var selCache = this.GetSelectionCache();
    var numElements = selCache.length;
    for (var i = 0; i < numElements; i++) {
      var theElement = selCache[i];
      if (elementType == null) theList.push(theElement);
      else {
        if (theElement.GetElementType() == elementType) theList.push(theElement);
      }
    }

    return theList;
  }

  SupportsZoom() {
    //Override me!
    return false;
  }

  ClearSelection() {
    var selCache = this.GetSelectionCache();

    var copySel = selCache.slice(0);
    var selObj = copySel.pop();
    while (selObj != null) {
      if (selObj["invalid"]) {
        var found = this.RemoveFromSelectionCache(selObj);
        if (!found) console.log("ClearSelection Not Found:", selObj.ObjectName());
      } else this.DoSelectElement(selObj, false);
      selObj = copySel.pop();
    }

    var numElements2 = selCache.length;
    if (numElements2 > 0) console.log("ClearSelection Issue:", numElements2);
  }

  // Before we render the panel - make sure all elements are enabled/disabled as appropriate
  PrepRender(theWSMgr) {}

  FindCmdShortCut(keyInfo) {
    var numElements = this.GetNumElements();
    for (var i = 0; i < numElements; i++) {
      var theElement = this.fElements[i];
      if (theElement.IsEnabled()) {
        if (theElement.MatchCmdShortCut(keyInfo)) return theElement;
      }
    }

    return null;
  }

  AssembleCommand(theWSMgr) {
    // Assemble a command - may need to reference the panel elements, the QWSMgr or the QDoc
  }

  ExecuteCommand(aCmd) {
    // Execute the command inside the panel
    return false;
  }

  // Command generated from an alert
  ExecuteAlertCommand(aCmd) {
    // Execute the command inside the panel
    return this.ExecuteCommand(aCmd);
  }

  // Resize
  SetResizeBehavior(pinLeft, pinTop, pinRight, pinBottom) {
    var resizeBehavior = this.GetResizeBehavior();
    resizeBehavior.fPinLeft = pinLeft;
    resizeBehavior.fPinTop = pinTop;
    resizeBehavior.fPinRight = pinRight;
    resizeBehavior.fPinBottom = pinBottom;
    this.fPanelResizeBehavior = resizeBehavior;
  }

  SetResizeToCenter(doResizeToCenter) {
    var resizeBehavior = this.GetResizeBehavior();
    resizeBehavior.fPinCenter = doResizeToCenter;
    this.fPanelResizeBehavior = resizeBehavior;
  }

  SetNeedsCustomResize(needsCustomResize) {
    var resizeBehavior = this.GetResizeBehavior();
    resizeBehavior.fCustomResize = needsCustomResize;
    this.fPanelResizeBehavior = resizeBehavior;
  }

  GetResizeBehavior() {
    if (this.fPanelResizeBehavior == null) this.fPanelResizeBehavior = new QResizeBehavior();

    return this.fPanelResizeBehavior;
  }

  DoCustomResize() {
    // Override this
  }

  PostStandardResize() {
    // Override this if you want to do something after the resize
  }

  StandardResize(origParentWidth, origParentHeight, newParentWidth, newParentHeight) {
    var resizeBehavior = this.GetResizeBehavior();

    var pinLeft = resizeBehavior.fPinLeft;
    var pinRight = resizeBehavior.fPinRight;
    var pinTop = resizeBehavior.fPinTop;
    var pinBottom = resizeBehavior.fPinBottom;
    var pinCenter = resizeBehavior.fPinCenter;

    var origPWidth = this.fPortWidth;
    var origPHeight = this.fPortHeight;

    var origWidth = this.fWidth;
    var origHeight = this.fHeight;

    var newPHSize = origPWidth;
    var newPVSize = origPHeight;

    var newHSize = newPHSize;
    var newVSize = newPVSize;

    if (origHeight > origPHeight) newVSize = origHeight;

    if (origWidth > origPWidth) newHSize = origWidth;

    var newPosX = this.fHorzOffset;
    var newPosY = this.fVertOffset;

    if (pinCenter) {
      newPosX =
        newPosX - CenterIt(origParentWidth, origWidth) + CenterIt(newParentWidth, origWidth);
      newPosY =
        newPosY - CenterIt(origParentHeight, origHeight) + CenterIt(newParentHeight, origHeight);
    }

    if (pinLeft && pinRight) {
      // Stretch right
      //	var xFactor = newParentWidth / origParentWidth;
      //	newHSize = Math.round(newHSize * xFactor);
      newPHSize = newPHSize + (newParentWidth - origParentWidth);
      if (newPHSize < 1) newPHSize = 1;
    } else if (pinLeft && !pinRight) {
      // Do not move or resize
    } else if (!pinLeft && pinRight) {
      // Move right
      newPosX = newPosX + (newParentWidth - origParentWidth);
      if (newPosX < 0) newPosX = 0;
    }

    if (pinTop && pinBottom) {
      // Stretch down
      //var yFactor = newParentHeight / origParentHeight;
      //newVSize = Math.round(newVSize * yFactor);
      newPVSize = newPVSize + (newParentHeight - origParentHeight);
      if (newPVSize < 1) newPVSize = 1;
    } else if (pinTop && !pinBottom) {
      // Do not move or resize
    } else if (!pinTop && pinBottom) {
      newPosY = newPosY + (newParentHeight - origParentHeight);
      if (newPosY < 0) newPosY = 0;
    }

    //console.log("Panel - OrigW:",origWidth,"OrigH:", origHeight,"NewW:",newHSize,"NewH:",newVSize);

    this.SizePanel(newPHSize, newPVSize, newHSize, newVSize);
    this.PositionPanel(newPosX, newPosY);

    var numElements = this.GetNumElements();
    for (var i = 0; i < numElements; i++) {
      var theElement = this.fElements[i];
      theElement.Resize(origPWidth, origPHeight, newPHSize, newPVSize);
    }

    this.PostStandardResize();
  }

  Resize(origParentWidth, origParentHeight, newParentWidth, newParentHeight) {
    var resizeBehavior = this.GetResizeBehavior();
    if (resizeBehavior.fCustomResize) this.DoCustomResize();
    else this.StandardResize(origParentWidth, origParentHeight, newParentWidth, newParentHeight);
  }

  AllowSelect() {
    return true;
  }

  // Z Plane used to determine rendering order
  AddZPlane(zPlane) {
    if (this.fZPlanes == null) this.fZPlanes = [];
    for (var curZPlaneIdx = this.fZPlanes.length; curZPlaneIdx <= zPlane; curZPlaneIdx++)
      this.fZPlanes.push([]);
  }

  SetMarqueeBehavior(marqueeBehavior) {
    this.fMarqueeBehavior = marqueeBehavior;
  }

  GetMarqueeBehavior() {
    return this.fMarqueeBehavior;
  }

  SetMarqueeEnabled(marqueeEnabled) {
    this.fMarqueeEnabled = marqueeEnabled;
  }

  IsMarqueeEnabled(timerDone) {
    return this.fMarqueeEnabled;
  }

  SetMarqueeRect(x1, y1, x2, y2) {
    var sx, ex;
    if (x1 < x2) {
      sx = x1;
      ex = x2;
    } else {
      sx = x2;
      ex = x1;
    }

    sx = this.GetLocalX(sx);
    ex = this.GetLocalX(ex);
    this.fMarqueeLeft = sx;

    var sy, ey;
    if (y1 < y2) {
      sy = y1;
      ey = y2;
    } else {
      sy = y2;
      ey = y1;
    }

    sy = this.GetLocalY(sy);
    ey = this.GetLocalY(ey);
    this.fMarqueeTop = sy;

    this.fMarqueeWidth = Math.abs(ex - sx);
    this.fMarqueeHeight = Math.abs(ey - sy);
    this.fDoDrawMarquee = true;
  }

  ClearDrawMarquee() {
    this.fDoDrawMarquee = false;
    this.fMarqueeLeft = 0;
    this.fMarqueeTop = 0;
    this.fMarqueeWidth = 0;
    this.fMarqueeHeight = 0;
  }

  ElementInRect(theElement, x, y, width, height, marqueeBehavior) {
    var elementLeft = theElement.GetPositionX();
    var elementTop = theElement.GetPositionY();
    var elementRight = elementLeft + theElement.GetWidth();
    var elementBottom = elementTop + theElement.GetHeight();

    var marqueeLeft = x;
    var marqueeTop = y;
    var marqueeRight = x + width;
    var marqueeBottom = y + height;

    var overlap = false;
    switch (marqueeBehavior) {
      case enumMarqueeBehavior.fullOverlap:
        overlap =
          elementLeft >= marqueeLeft &&
          elementRight <= marqueeRight &&
          elementTop >= marqueeTop &&
          elementBottom <= marqueeBottom;
        break;
      case enumMarqueeBehavior.partialOverlap:
        var horzIntersection = linesOverlap(marqueeLeft, marqueeRight, elementLeft, elementRight);
        var vertIntersection = linesOverlap(marqueeTop, marqueeBottom, elementTop, elementBottom);
        overlap = horzIntersection && vertIntersection;
        break;
      case enumMarqueeBehavior.smartOverlap:
        var horzBuffer = 35;
        var vertBuffer = 20;
        overlap =
          elementLeft >= marqueeLeft - horzBuffer &&
          elementRight <= marqueeRight + horzBuffer &&
          elementTop >= marqueeTop - vertBuffer &&
          elementBottom <= marqueeBottom + vertBuffer;
        break;
    }

    return overlap;
  }

  DrawMarquee(origX, origY, currentX, currentY) {
    // Draw outline area
    // console.log("Draw Marquee :", origX, " " , origY, " " , currentX, " ", currentY);
  }

  NoDragMarquee() {
    if (this.fMarqueeWidth == 0 && this.fMarqueeHeight == 0) return true;
    else return false;
  }

  SelectAll() {
    this.ClearSelection();
    var numElements = this.GetNumElements();
    for (var i = 0; i < numElements; i++) {
      var theElement = this.fElements[i];
      if (theElement.IsShown() && this.IncludeElementInSelection(theElement))
        this.DoSelectElement(theElement, true);
    }
  }

  SelectElementsInMarquee(shiftKey) {
    var numElements = this.GetNumElements();
    for (var i = 0; i < numElements; i++) {
      var theElement = this.fElements[i];
      if (this.fMarqueeSelectNestedElements) this.SelectElementTree(theElement, shiftKey);
      else this.MarqueeSelect(theElement, shiftKey);
    }
  }

  MarqueeSelect(targetElement, shiftKey) {
    if (targetElement.IsShown() && this.IncludeElementInSelection(targetElement)) {
      var marqueeBehavior = this.fMarqueeBehavior;
      var elementInRect = this.ElementInRect(
        targetElement,
        this.fMarqueeLeft,
        this.fMarqueeTop,
        this.fMarqueeWidth,
        this.fMarqueeHeight,
        marqueeBehavior
      );
      if (elementInRect) {
        var selectIt = true;
        if (shiftKey) selectIt = !targetElement.IsSelected();
        this.DoSelectElement(targetElement, selectIt);
      }
    }
  }

  SelectElementTree(targetElement, shiftKey) {
    this.MarqueeSelect(targetElement, shiftKey);
    if (targetElement.fElements != null) {
      for (var i = 0; i < targetElement.fElements.length; i++) {
        var subElement = targetElement.fElements[i];
        this.SelectElementTree(subElement, shiftKey);
      }
    }
  }

  DoDrawMarquee(drawBuffer) {
    if (!this.fDoDrawMarquee) return;
    var ctx = drawBuffer.getContext("2d");
    ctx.save();
    ctx.scale(Globals._dpr, Globals._dpr);
    ctx.fillStyle = "#CAE5FF";
    ctx.strokeStyle = "#7EBFFF";
    ctx.linewidth = 2;
    var sf = this.fScaleFactor;
    ctx.strokeRect(
      this.fMarqueeLeft * sf,
      this.fMarqueeTop * sf,
      this.fMarqueeWidth * sf,
      this.fMarqueeHeight * sf
    );
    ctx.globalAlpha = 0.5;
    ctx.fillRect(
      this.fMarqueeLeft * sf,
      this.fMarqueeTop * sf,
      this.fMarqueeWidth * sf,
      this.fMarqueeHeight * sf
    );
    ctx.restore();
  }

  //=================================================================================================
  // Allow user to extend the selection using the shift key
  ShiftExtendsSelection() {
    return this.fShiftExtendsSelection;
  }

  CtrlExtendsSelection() {
    return this.fCtrlExtendsSelection;
  }

  //=================================================================================================
  // Right click
  DoHandleRightClick(hitElement, x, y, event) {}

  HandleRightClick(hitElement, x, y, event) {
    // var xLocal = this.GetLocalX(x);
    // var yLocal = this.GetLocalY(y);

    return this.DoHandleRightClick(hitElement, x, y, event);
  }

  //=================================================================================================
  // Keyboard handling
  PanelHandleKeyboard(keyInfo, targetElement, wsMgr) {
    return false;
  }

  PanelLosingTarget() {
    // Override this - to commit any changes when a user clicks on an element in another panel
  }

  //=================================================================================================
  // Clipboard Support
  CanPaste(clipboardContents) {
    return false;
  }

  //=================================================================================================
  // Optimized selection
  GetSelectionCache() {
    if (this.fSelectionCache == null) this.fSelectionCache = [];

    return this.fSelectionCache;
  }

  AddToSelectionCache(anElement) {
    //	console.log("AddToSelectionCache", anElement.ObjectName())

    var s = this.GetSelectionCache();
    var index = s.indexOf(anElement);
    if (index == -1) {
      s.push(anElement);
      //	var numElements2 = s.length;
      //   console.log("AddToSelectionCache:",anElement.ObjectName(), " ", numElements2);
    }
  }

  RemoveFromSelectionCache(anElement) {
    var s = this.GetSelectionCache();
    var found = false;
    var index = s.indexOf(anElement);
    if (index != -1) {
      s.splice(index, 1);
      //var numElements2 = s.length;
      found = true;
      //console.log("RemoveFromSelectionCache:Found:",anElement.ObjectName(), " ", numElements2);
    }

    return found;
  }

  GetSelectableElements() {
    var selectableElems = [];
    if (this.fElements == null) return selectableElems;

    return this.fElements.filter(function (item) {
      return item.fIsSelectable;
    });
  }

  //=================================================================================================
  // Cursor handling
  SetCursor(aMode) {
    this.fCurCursor = aMode;
  }

  GetCursor() {
    return this.fCurCursor;
  }

  //=================================================================================================
  // Render Modes
  GetRenderMode() {
    return this.fRenderMode;
  }

  SetRenderMode(renderMode) {
    this.fRenderMode = renderMode;
  }

  //=================================================================================================
  // Debugging
  ObjectName() {
    return "QPanel";
  }

  // handling active selection vs standard selection
  GetHighlightCache() {
    if (this.fHighlightCache == null) this.fHighlightCache = [];

    return this.fHighlightCache;
  }

  // ==================================================================================================
  RemoveFromHighlightCache(anElement) {
    var s = this.GetHighlightCache();
    var found = false;
    var index = s.indexOf(anElement);
    if (index != -1) {
      s.splice(index, 1);
      //var numElements2 = s.length;
      found = true;
      //console.log("RemoveFromSelectionCache:Found:",anElement.ObjectName(), " ", numElements2);
    }

    return found;
  }

  DoHighlightElement(theElement, highlight) {
    if (highlight) {
      this.AddToHighlightCache(theElement);
    } else this.RemoveFromHighlightCache(theElement);
    this.PerformHighlight(theElement, highlight);
  }

  PerformHighlight(theElement, setActive) {
    theElement.SetHighlighted(setActive);
  }

  AddToHighlightCache(anElement) {
    //	console.log("AddToSelectionCache", anElement.ObjectName())

    var s = this.GetHighlightCache();
    var index = s.indexOf(anElement);
    if (index == -1) {
      s.push(anElement);
      //	var numElements2 = s.length;
      //   console.log("AddToSelectionCache:",anElement.ObjectName(), " ", numElements2);
    }
  }

  ClearHighlightCache() {
    var selCache = this.GetHighlightCache();

    var copySel = selCache.slice(0);
    var selObj = copySel.pop();
    while (selObj != null) {
      if (selObj["invalid"]) {
        var found = this.RemoveFromHighlightCache(selObj);
        if (!found) console.log("ClearActiveSelection Not Found:", selObj.ObjectName());
      } else this.DoHighlightElement(selObj, false);
      selObj = copySel.pop();
    }

    var numElements2 = selCache.length;
    if (numElements2 > 0) console.log("ClearActiveSelection Issue:", numElements2);
  }

  ArrowKeyNavigation(elemClass, keyCode) {
    if (this.fElements == null) return;
    var searchTE = this.fBackgroundPanel.fSearchTE;
    if (this.fPanelRef) {
      searchTE = this.fPanelRef.fSearchTE;
    }
    var keyUp = keyCode === kUpArrow;
    var keyTabUp = Globals._wsMgr.ShiftDown() && keyCode === kTabKey;
    var theElements = this.fElements.filter(function (item) {
      return item instanceof elemClass;
    });
    var highlightCache = this.GetHighlightCache();
    var selectionCache = this.GetSelectionCache();
    if (highlightCache.length === 0 && selectionCache.length > 0) highlightCache = selectionCache;
    var targetElem = theElements[0];
    var panY = null;
    var targetPanel = this;
    var backToSearch = false;
    if (highlightCache.length === 1) {
      targetElem = null;
      var elemIdx = -1;
      for (var i = 0; i < theElements.length; i++) {
        if (theElements[i] === highlightCache[0]) {
          elemIdx = i;
          break;
        }
      }
      if (i === -1) return;

      if (keyUp || keyTabUp) {
        targetIdx = i > 0 ? elemIdx - 1 : theElements.length - 1;
        targetElem = theElements[targetIdx];
        if (
          targetIdx === theElements.length - 1 &&
          targetPanel.fBackgroundPanel.fHasVertScrollBar
        ) {
          panY = targetElem.fVertOffset - this.fPortHeight;
          if (searchTE && keyTabUp) {
            panY = 0;
            backToSearch = true;
          }
        }
      } else {
        var targetIdx = i < theElements.length - 1 ? elemIdx + 1 : 0;
        targetElem = theElements[targetIdx];
        if (targetIdx === 0 && targetPanel.fBackgroundPanel.fHasVertScrollBar) {
          panY = 0;
          if (searchTE && keyCode === kTabKey) {
            backToSearch = true;
          }
        }
      }
    } else if (highlightCache.length > 1) {
      targetElem = highlightCache[0];
    }

    if (backToSearch) {
      targetElem = searchTE;
      if (this.fPanelRef) {
        targetPanel = this.fPanelRef;
      } else {
        targetPanel = targetElem.fParentPanel;
      }
    }

    this.fWSMgr.SetKeyboardTarget(targetElem, targetPanel, null);
    if (targetElem == null) return;

    this.ClearHighlightCache();
    if (targetElem instanceof elemClass) this.DoHighlightElement(targetElem, true);
    if (panY != null) this.SetPanY(panY);

    if (!backToSearch) {
      var shift =
        targetIdx === 0 || targetIdx === theElements.length - 1 ? 0 : keyUp || keyTabUp ? -1 : 1;
      var nextElement = theElements[targetIdx + shift];
      if (!nextElement) {
        nextElement = keyUp || keyTabUp ? theElements[theElements.length - 1] : theElements[0];
      }

      var nextY = nextElement.GetPositionY();

      var curElemPosY = targetElem.GetPositionY();

      if (nextElement != targetElem) var elemHeight = Math.abs(nextY - curElemPosY);
      else elemHeight = targetElem.GetHeight();

      var portHeight = this.GetPortHeight();
      var curPanY = this.fPanY;
      var curPanX = this.fPanX;

      var elemIsInPortBounds =
        curPanY < curElemPosY && curElemPosY + elemHeight < curPanY + portHeight;
      if (!elemIsInPortBounds) {
        var deltaY = 0;
        if ((keyUp || keyTabUp) && curPanY > curElemPosY) {
          deltaY = elemHeight;
        } else if (curElemPosY + elemHeight > curPanY + portHeight) {
          deltaY = -elemHeight;
        }
        if (deltaY !== 0) {
          this.PanPanel(curPanX, curPanY, 0, deltaY);
        }
      }
    }
  }

  //==========================================================================
  // entry point to creating display port and pushing the base panel
  InitializeSmartDisplayPort(startRender, portX, portY) {
    this.fPortStartX = portX != null ? portX : 0;
    this.fPortStartY = portY != null ? portY : 0;
    var defaultHeaderHeight = kFramelessHeaderHeight;
    if (this.fHeaderStr) {
      if (this.fHeaderHeight != null) defaultHeaderHeight = this.fHeaderHeight;
      this.fPortStartY += defaultHeaderHeight + 1; // 1 pixel spacing for border space between port and header (if one should exist)
    }

    this.fHasDisplayPort = true;
    if (Globals._mobileDevice) {
      this.SetPanelPanHideScrollBarMode();
    }
    if (startRender) {
      this.fWSMgr.PushPanel(this);
      this.UpdatePanel();
    }
  }

  // static port panel's can be tricky due to issues resizing - this will need work
  InitializeBasicViewPortPanel(startRender, portX, portY) {
    this.fPortStartX = portX != null ? portX : 0;
    this.fPortStartY = portY != null ? portY : 0;
    var defaultHeaderHeight = kFramelessHeaderHeight;
    if (this.fHeaderStr) {
      if (this.fHeaderHeight != null) defaultHeaderHeight = this.fHeaderHeight;
      this.fPortStartY += defaultHeaderHeight + 1; // 1 pixel spacing for border space between port and header (if one should exist)
    }
    this.fHasDisplayPort = true;
    if (Globals._mobileDevice) {
      this.SetPanelPanHideScrollBarMode();
    }
    this.fWSMgr.PushPanel(this);
    this.InitializeExtras();
    this.CreateDisplayPort();
    this.OneTimePanelPrep();
    this.UpdatePanel();
  }

  OneTimePanelPrep() {
    // prep panel with function that runs just once
  }

  SetBottomBuffer(buffer) {
    this.fBottomBuffer = buffer;
  }

  SetRightBuffer(buffer) {
    this.fRightBuffer = buffer;
  }

  //=============================================================================
  InitializeContainerDisplayPort(startRender) {
    this.fPortStartX = 0;
    this.fPortStartY = 0;

    this.fHasDisplayPort = true;
    this.fIsContainer = true;

    if (Globals._mobileDevice) {
      this.SetPanelPanHideScrollBarMode();
    }
    if (startRender) {
      this.fWSMgr.PushPanel(this);
      this.UpdatePanel();
    }
  }

  SetParentContainer(container) {
    this.fParentContainer = container;
  }

  GetParentContainer() {
    return this.fParentContainer;
  }

  //================================================================================
  // unified panel update
  UpdatePanel() {
    // clear panel
    this.RemoveAllElements();

    // allow setting of custom panel parameters
    this.InitializeExtras();

    // add header/footer/dragger/exit/help buttons
    // set when initializing panel using initframelesspanelbasics method
    // or setting the appropriate params
    this.AddFramelessPanelBasics();

    // create port panel
    if (this.fHasDisplayPort) {
      this.InitializeDisplayPort();
    }

    // add panel content and update display port
    var dimensions = this.AddContent();

    if (this.fHasDragger) {
      this.LinkAssociates(this.fPanelDragger);
    }

    if (this.fHasDisplayPort) {
      this.AddScrollBars();
      var reqWidth = this.GetDisplayPortMaxWidth();
      var reqHeight = this.GetDisplayPortMaxHeight();
      if (typeof dimensions === "object" && dimensions !== null) {
        if (dimensions["width"] != null) reqWidth = dimensions["width"]; // should be an integer value
        if (dimensions["height"] != null) reqHeight = dimensions["height"];
      }
      this.UpdateDisplayPort(reqWidth, reqHeight);
    }

    // panning and extras
    this.PanExtras();
    this.AddExtras(dimensions);

    if (this.fPageCount > 1 && this.fAllowPaging) {
      this.AddPagingControlButtons();
      this.AddPaginationLinks();
    }

    // reaquire prior targets
    this.fWSMgr.RegainKeyboardFocus();
  }

  LinkAssociates(panelDragger) {
    if (!panelDragger) return;

    var associatedPanels = this.GetAssociatedPanels();
    if (associatedPanels == null) return;

    for (var i = 0; i < associatedPanels.length; i++) {
      var newAssociate = associatedPanels[i];
      if (panelDragger.fAssociatedPanels.indexOf(newAssociate) === -1)
        panelDragger.AssociatePanel(newAssociate);
      if (newAssociate.GetAssociatedPanels().length > 0) newAssociate.LinkAssociates(panelDragger);
    }
  }

  //================================================================================
  // core display port functions
  InitializeDisplayPort() {
    if (this.fPortPanel) {
      this.fPortPanel.RemoveAllElements();
      this.fPortPanel.PositionPanel(
        this.GetPositionX() + this.fPortStartX,
        this.GetPositionY() + this.fPortStartY
      );
    } else if (this.fNestedDisplayPort) {
      this.CreateNestedDisplayPort();
    } else {
      this.CreateDisplayPort();
    }
  }

  //=======================================================
  // Create Display Port Default
  CreateDisplayPort() {
    var portX = this.fPortStartX;
    var portY = this.fPortStartY;

    if (this.fPortStartY === 0 && this.fHeader != null) this.fPortStartY = this.fHeader.fHeight;

    var portPanel = this.GetPortPanel();
    portPanel.PositionPanel(this.GetPositionX() + portX, this.GetPositionY() + portY);
    portPanel.InitPortPanel(this);
    portPanel.SizePanel(this.fWidth, this.fHeight); // defensive code against premature render ws call before the port panel has been updated and sized, leading to panel offscreenbuffer render crash
    if (this.fDisplayPortColor !== null) portPanel.SetFillColor(this.fDisplayPortColor);
    else portPanel.SetFillColor(this.GetFillColor());
    portPanel.SetShownState(this.IsShown()); // tab panel shown state set before port init
    portPanel.SetPanelMode(this.GetPanelMode());
    portPanel.SetAllowPanOnElemHit(this.GetAllowPanelPanOnElemHit());
    this.fPortPanel = portPanel;
    portPanel.fRenderPhoenix = this.fRenderPhoenix;
    // TODO this should be on by default - i think the QDropDown is the only place where this is overriding this - and subsequently why this was written this way to begin with.
    if (this.fMatchParentZLayer && this.fZLayer) {
      this.fPortPanel.SetZLayer(this.fZLayer);
    }
    if (this.fUIColors) {
      this.fPortPanel.fUIColors = this.fUIColors;
    }

    if (this.fCustomViewPortFormatting) {
      this.FormatPortPanel(this.fPortPanel);
    } else if (this.fBasicViewPortFormatting) {
      this.SetBasicPortPanelFormatting();
    }
    this.AssociatePanel(this.fPortPanel);
  }

  SetBasicPortPanelFormatting() {
    var portPanel = this.fPortPanel;
    portPanel.SetBorderRadius(1);
    portPanel.SetBorderThickness(2);
    portPanel.SetBorderStyle(enumPanelBorderStyle.roundBorder);
    portPanel.SetBorderColor(shadeColor(this.fUIColors.GetLightPanelBorderColor(), -5));
    portPanel.SetFillColor(this.fUIColors.GetViewPortColor());
  }

  FormatPortPanel(portPanel) {
    // override this to apply formatting for port panel ie borderstyle, fill, etc.
  }

  //==============================================================
  // Create Nested Display Port
  AddContent() {
    // override this - to be called during update panel unified update routine
  }

  UpdateContent() {
    //override this - to be called prior to updatepanel
  }

  AddNestedPanel(nestedPanel, yOffset) {
    // by default allow pan + click on nested panels in mobile
    if (Globals._mobileDevice) {
      nestedPanel.SetMobileNestedPanelPanClickAbility();
    }
    nestedPanel.fControlOverride = true; // hack remove this and fix dohandlemousewheel
    nestedPanel.fNestedDisplayPort = true;
    nestedPanel.fScrollBarV = true; // hack remove this and fix dohandlemousewheel
    nestedPanel.SetBorderStyle(enumPanelBorderStyle.dynamicClipBorder);
    nestedPanel.SetBorderThickness(2);
    nestedPanel.SetShownState(this.IsShown());
    nestedPanel.SetNestedStartYOffset(yOffset);
    nestedPanel.SetParentContainer(this);
    this.AssociatePanel(nestedPanel);
  }

  CreateNestedDisplayPort() {
    var portX = this.fPortStartX;
    var portY = this.fPortStartY;

    // MAIN DISPLAY PORT
    var portPanel = this.GetDynamicPortPanel();
    portPanel.PositionPanel(this.GetPositionX() + portX, this.GetPositionY() + portY);
    portPanel.InitPortPanel(this);
    portPanel.SetShownState(this.IsShown());
    portPanel.fControlOverride = true;
    portPanel.SetBorderStyle(enumPanelBorderStyle.dynamicClipBorder);
    portPanel.SetParentContainer(this.GetParentContainer());
    portPanel.SetPanelMode(this.GetPanelMode());
    portPanel.fDynamicNoHit = this.fDynamicNoHit;
    this.fPortPanel = portPanel;
    if (this.fUIColors) {
      this.fPortPanel.fUIColors = this.fUIColors;
    }
    this.AssociatePanel(this.fPortPanel);
  }

  AddScrollBars() {
    var portX = this.fPortStartX;
    var portY = this.fPortStartY;

    var maxHeight = this.GetDisplayPortMaxHeight();
    var maxWidth = this.GetDisplayPortMaxWidth();

    this.fScrollBarV = new QScrollBar();
    this.PushElement(this.fScrollBarV);
    this.fScrollBarV.InitScrollBar(this, this.fPortPanel, enumScrollBarType.vertical);
    this.fScrollBarV.fStartY = portY;
    this.fScrollBarV.fMaxY = maxHeight + portY;
    this.fScrollBarV.fStartX = maxWidth + portX - this.fScrollBarV.GetWidth();
    this.fHasVertScrollBar = false;

    this.fScrollBarH = new QScrollBar();
    this.PushElement(this.fScrollBarH);
    this.fScrollBarH.InitScrollBar(this, this.fPortPanel, enumScrollBarType.horizontal);
    this.fScrollBarH.fStartX = portX;
    this.fScrollBarH.fStartY = portY + maxHeight - this.fScrollBarH.GetHeight();
    this.fScrollBarH.fMaxX = maxWidth + portX;
    this.fHasHorzScrollBar = false;
  }

  UpdateDisplayPort(totalWidth, totalHeight) {
    var portPanel = this.fPortPanel;
    var maxAllowedPanelSize = Math.floor(kMaxPanelSize / Globals._dpr);
    var maxHeight = this.GetDisplayPortMaxHeight();
    var maxWidth = this.GetDisplayPortMaxWidth();

    var curHeight = maxHeight;
    var curWidth = maxWidth;

    var vertScrollOffset = 0;
    var horzScrollOffset = 0;

    this.fScrollBarV.SetAcceptsClicks(false);
    this.fScrollBarH.SetAcceptsClicks(false);

    if (totalHeight > maxHeight) {
      curHeight = totalHeight;
      vertScrollOffset = this.fScrollBarV.GetWidth();
      this.fHasVertScrollBar = true;
      this.fScrollBarV.SetAcceptsClicks(true);
    }
    if (totalWidth > maxWidth) {
      curWidth = totalWidth;
      horzScrollOffset = this.fScrollBarH.GetHeight();
      this.fHasHorzScrollBar = true;
      this.fScrollBarH.SetAcceptsClicks(true);
    }

    var hideScrollBar = this.GetHideScrollBar();
    if (hideScrollBar) {
      vertScrollOffset = 0;
      horzScrollOffset = 0;
    }

    if (curHeight > maxAllowedPanelSize) curHeight = maxAllowedPanelSize;

    if (curWidth > maxAllowedPanelSize) curWidth = maxAllowedPanelSize;

    portPanel.SizePanelAndPort(
      curWidth - vertScrollOffset,
      curHeight - horzScrollOffset,
      maxWidth - vertScrollOffset,
      maxHeight - horzScrollOffset
    );

    this.fScrollBarV.UpdateScrollBar();
    this.fScrollBarH.UpdateScrollBar();

    if (hideScrollBar) {
      if (this.fScrollBarH) this.fScrollBarH.SetShownState(false);

      if (this.fScrollBarV) this.fScrollBarV.SetShownState(false);
    }
  }

  //==========================================================================
  // helper functions for basic update pipe
  GetDisplayPortMaxHeight() {
    var bottomBuffer = this.GetPanelBottomBuffer();
    return this.fHeight - this.fPortStartY - bottomBuffer;
  }

  GetDisplayPortMaxWidth() {
    var rightBuffer = this.GetPanelRightBuffer();
    return this.fWidth - this.fPortStartX - rightBuffer;
  }

  GetPanelTopBuffer() {
    return this.fHeader ? this.fHeader.fHeight : 0;
  }

  GetPanelBottomBuffer() {
    var pageCount = this.GetPageCount();
    var addPageMargin = this.fAllowPaging && pageCount > 1;
    var bottomBuffer = 0;
    if (this.fBottomBuffer != null) {
      bottomBuffer = this.fBottomBuffer;
    }

    if (this.fFooter) bottomBuffer += this.fFooter.GetHeight() + this.fFooter.fBorderThickness * 2;

    if (addPageMargin) bottomBuffer += /*kPagingButtonHeight*/ 1 * 1.5;

    return bottomBuffer;
  }

  GetPanelRightBuffer() {
    var buffer = 0;
    if (this.fRightBuffer != null) buffer = this.fRightBuffer;
    return buffer;
  }

  GetPortPanel() {
    return Globals._wsMgr.GetPortPanel();
  }

  GetDynamicPortPanel() {
    const QFramelessConfigDynamicPortPanel =
      require("./QFramelessConfigDynamicPortPanel").QFramelessConfigDynamicPortPanel;
    return new QFramelessConfigDynamicPortPanel();
  }

  SetNestedStartYOffset(resetY) {
    this.fResetY = resetY;
  }

  GetNestedStartYOffset() {
    if (this.fResetY == null && this.fBackgroundPanel && this.fBackgroundPanel.fResetY != null) {
      return this.fBackgroundPanel.fResetY + this.fBackgroundPanel.fPortStartY;
    }
    return this.fResetY;
  }

  SetFramelessPanelBasics(header, footer, drag, exit, help, saveCmd, cancelCmd, resetCmd) {
    this.fHeaderStr = header; // header string
    this.fHasFooter = footer; // bool true or false
    this.fHasDragger = drag; // bool true or false
    this.fHasExit = exit; // bool true or false
    this.fHelpCode = help; //  help cmd code string. If the help code is generated later on, then passing 'root' as a param will position the future help code. Otherwise, the help button will appear on the panel header's left.
    this.fBasicSaveCmd = saveCmd;
    this.fBasicCancelCmd = cancelCmd;
    this.fBasicResetCmd = resetCmd;
  }

  // used for most cases cases
  SetBorderlessPanelFrameAndFill() {
    this.SetBorderRadius(6);
    this.SetBorderThickness(0);
    this.SetBorderStyle(enumPanelBorderStyle.roundBorder);
    this.SetFillColor(this.fUIColors.GetSecondaryPanelFillColor());
    this.SetShadowOn(true);
  }

  //===================================================================
  // std base panel and sub panel formatting
  SetNestedFrameAndFill() {
    this.SetBorderRadius(6);
    this.SetBorderThickness(2);
    this.SetBorderStyle(enumPanelBorderStyle.roundBorder);
    this.SetBorderColor(this.fUIColors.GetLightPanelBorderColor());
    this.SetFillColor(this.fUIColors.GetPadColor());
  }

  SetFloatingPanelFrameAndFill() {
    this.SetBorderRadius(6);
    this.SetBorderThickness(2);
    this.SetBorderColor(this.fUIColors.GetLightPanelBorderColor());
    this.SetBorderStyle(enumPanelBorderStyle.roundBorder);
    this.SetFillColor(this.fUIColors.GetSecondaryPanelFillColor());
    this.SetModalOn(true);
    this.SetShadowOn(true);
  }

  //======================================
  InitializeExtras() {
    // override for routine to execute before addcontent()
  }

  AddExtras(dimensions) {
    // override for routine to execute after addcontent()
  }

  UpdatePanels() {
    this.UpdatePanel();
    var associates = this.GetAssociatedPanels();
    for (var i = 0; i < associates.length; i++) {
      associates[i].UpdatePanel();
    }
    if (this.fPanelDragger) this.LinkAssociates(this.fPanelDragger);
  }

  AddFooter() {
    var altFill = Globals._themeMode.fill.secondary;
    var lightBorder = Globals._themeMode.lightborder;
    var Footer = this.AddFramelessHeader("", altFill);
    Footer.SetHeight(1.5 * kFramelessHeaderHeight);
    Footer.SetPositionY(this.fHeight - Footer.fHeight);
    Footer.SetBorderColor(altFill);
    Footer.SetBorderThickness(0);
    Footer.SetBorderStyle(enumElementBorderStyle.singleBorder);
    this.fFooter = Footer;
    return Footer;
  }

  ShouldShowHotLink() {
    var userRole = Globals._accountInfo.GetUserRole();
    return userRole === kAdminUser && this.fHasHotLink === true;
  }

  AddDragger() {
    var headerHeight = this.fHeader ? this.fHeader.fHeight : kFramelessHeaderHeight;

    this.fPanelDragger = new QFramelessPanelDragger();
    this.fPanelDragger.InitPanelDragger(this);
    this.fPanelDragger.PositionElement(0, 0);
    this.fPanelDragger.SizeElement(this.fWidth, headerHeight);
    this.PushElement(this.fPanelDragger);
  }

  ValidateCut() {
    return true;
  }

  AddFramelessPanelBasics() {
    var padding =
      this.fBorderRadius != null ? Div2Floor(this.fBorderRadius) : this.fBorderThickness;
    var topLeftButtonOffset = this.fCornerButtonOffset + padding;

    if (this.fHeaderStr) {
      this.fHeader = this.AddFramelessHeader(this.fHeaderStr); // 'center', 'left' etc. 'center' by default
    }

    if (this.fHasFooter) {
      this.AddFooter();
    }

    var headerHeight = this.fHeader ? this.fHeader.fHeight : kFramelessHeaderHeight;

    if (this.fHasDragger) {
      this.AddDragger();
    }

    var xPos = this.fWidth - topLeftButtonOffset;
    if (this.fHasExit) {
      var exitbutton = this.AddFramelessExitButton();
      exitbutton.SetCmdCode("closePanel");
      xPos -= exitbutton.fWidth;
      exitbutton.SetPositionX(xPos);
      exitbutton.SetPositionY(CenterIt(headerHeight, exitbutton.fHeight));
      this.fExitButton = exitbutton;
      xPos -= 5;
    }

    if (this.fHelpCode) {
      var helpButton = this.AddHelpButton();
      xPos -= helpButton.fWidth;
      helpButton.SetPositionX(xPos);
      helpButton.SetPositionY(CenterIt(headerHeight, helpButton.fHeight));
      this.fHelpButton = helpButton;
      xPos -= 5;
    }
    if (this.ShouldShowHotLink()) {
      var hotLinkButton = this.AddHotLinkButton();
      var hotLinkX = topLeftButtonOffset;
      if (this.fHotLinkRight) {
        hotLinkX = xPos - hotLinkButton.fWidth;
      }
      hotLinkButton.SetPositionX(hotLinkX);
      hotLinkButton.SetPositionY(CenterIt(headerHeight, hotLinkButton.fHeight));
      this.fHotLinkButton = hotLinkButton;
    }

    var buttonSpace = 10;
    if (this.fBasicSaveCmd) {
      var saveStr = this.fSaveStr ? this.fSaveStr : appstr("Save");
      var saveButton = this.AddFooterButton(
        this.fBasicSaveCmd,
        saveStr,
        uFramelessPanelColorDarker
      );
      saveButton.SetPositionX(this.fWidth - saveButton.GetWidth() - buttonSpace);
      this.fSaveButton = saveButton;
    }

    if (this.fBasicCancelCmd) {
      var xPos = this.fBasicSaveCmd != null ? this.fSaveButton.GetPositionX() : this.fWidth;
      var cancelStr = this.fCancelStr ? this.fCancelStr : appstr("Cancel");
      var cancelColor = this.fCancelColor ? this.fCancelColor : kGrayCancel;
      var cancelButton = this.AddFooterButton(this.fBasicCancelCmd, cancelStr, cancelColor);
      cancelButton.SetPositionX(xPos - cancelButton.GetWidth() - buttonSpace);
      this.fCancelButton = cancelButton;
    }

    if (this.fBasicResetCmd) {
      var resetStr = this.fResetStr ? this.fResetStr : appstr("Reset");
      this.fResetButton = this.AddFooterButton(this.fBasicResetCmd, resetStr, kChocolate);
    }
  }

  AddFooterButton(cmdCode, label, color) {
    var buttonSpacing = 10;
    var footerHeight = this.fFooter ? this.fFooter.fHeight : kFramelessHeaderHeight * 1.5;
    if (label == null) label = appstr("notset");
    var footerButton = AddBubbleButton(
      this,
      0,
      0,
      label,
      color ? color : this.fUIColors.GetLinkTextBlueColor(),
      cmdCode,
      kAlertButtonRadius
    );
    footerButton.SetPositionX(buttonSpacing);
    footerButton.SetPositionY(
      this.fHeight - CenterIt(footerHeight, footerButton.fHeight) - footerButton.fHeight
    );
    return footerButton;
  }

  AddFramelessExitButton() {
    return AddFramelessExitButton(this);
  }

  // Todo add param for font size here - some of our headers need larger text than others
  AddFramelessHeader(headerLabel, color) {
    var headerHeight = this.fHeaderHeight ? this.fHeaderHeight : kFramelessHeaderHeight;
    if (this.fHeaderHeight != null) headerHeight = this.fHeaderHeight;
    return this.AddPanelHeader(
      headerHeight,
      headerLabel,
      this.fHeaderFontSize ? this.fHeaderFontSize : 14,
      color ? color : uFramelessPanelColorDarker,
      3,
      "center"
    );
  }

  InitPanelCollection() {
    this.fPanelCollection = new QPanelCollection();
    this.fPanelCollection.InitCollection(Globals._wsMgr);
  }

  // BE AWARE: this function handles pushing panel to wsmgr!
  AssociatePanel(panel) {
    if (panel == null) return;

    if (this.fPanelCollection == null) {
      this.InitPanelCollection();
    }

    this.fPanelCollection.AddPanel(panel);
  }

  UpdateNestedPanels() {
    var associates = this.fPortPanel.GetAssociatedPanels();
    for (var i in associates) {
      var associatePanel = associates[i];
      associatePanel.UpdateContent();
      associatePanel.UpdatePanel();
    }
  }

  PositionNestedPanels() {
    var associates = this.fPortPanel.GetAssociatedPanels();
    var n = associates.length;
    var x = this.fPortPanel.GetPositionX();
    var y = this.fPortPanel.GetPositionY();

    for (var i = 0; i < n; i++) {
      var associatePanel = associates[i];
      associatePanel.PositionPanel(x, y);
      y += associatePanel.GetHeight();
    }
  }

  GetAssociatedPanels() {
    var panelCollection = this.fPanelCollection;
    if (panelCollection == null) return [];
    return this.fPanelCollection.fPanels;
  }

  //============================================================================================
  // exit methods
  DoExit() {
    this.NukePanel();
  }

  DoBeforeExit() {
    //overrride this for dirty state checks - true ready to exit / false not ready
    return true;
  }

  DoAfterExit() {
    // override this
  }

  NukePanel() {
    if (this.fPanelCollection) {
      this.fPanelCollection.RemovePanels();
      this.fPanelCollection = null;
    }
    this.fWSMgr.RemovePanel(this);
  }

  //===========================================================================
  ExecuteBasicCommands(aCmd) {
    var handled = true;
    var cmdCode = aCmd.GetCmdCode();
    var srcPanel = aCmd.GetSourcePanel();
    var portPanel = this.fPortPanel;
    if (portPanel) {
      var origPanX = portPanel.GetPanX();
      var origPanY = portPanel.GetPanY();
      var curZoom = portPanel.GetScaleFactor();
    }
    var deltaX = 0;
    var deltaY = 0;

    switch (cmdCode) {
      case "closePanel":
        // TODO Warning: Using the frameless exit button for panel removal bypasses any existing cmd handling done by the panel's ExecuteCommand() call AND/OR handling done by the wsmgr.
        var readyToClose = this.DoBeforeExit();
        if (readyToClose) {
          this.DoExit();

          this.DoAfterExit();
        }
        break;
      case "HotLink":
        if (srcPanel.fCloseSourcePanel === true) srcPanel.NukePanel();
        //else if (srcPanel.fPanelDragger != null)
        //{
        //	srcPanel.fPanelDragger.SetIsControl(false);
        //}
        handled = false;
        break;
      case "JumpPan":
        var subPanCmd = aCmd["panCmd"];
        var targetPanel = aCmd["panTarget"] ? aCmd["panTarget"] : this;
        var subHandled = true;
        switch (subPanCmd) {
          case "PanToStartX":
            targetPanel.SetPanX(0);
            break;
          case "PanToEndX":
            targetPanel.SetPanX(Math.abs(targetPanel.fWidth - targetPanel.fPortWidth));
            break;
          case "PanToStartY":
            targetPanel.SetPanY(0);
            break;
          case "PanToEndY":
            targetPanel.SetPanY(Math.abs(targetPanel.fHeight - targetPanel.fPortHeight));
            break;
          default:
            subHandled = false;
            break;
        }
        if (subHandled && targetPanel.fBackgroundPanel) targetPanel.fBackgroundPanel.PanExtras();
        break;
      case "JumpToPage":
        var page = aCmd.GetSourceElement().fPage;
        this.SetCurrentPage(page);
        this.UpdatePanel();
        break;
      case "PrevPage":
        this.PageContent(false);
        break;
      case "NextPage":
        this.PageContent(true);
        break;
      case "EnterMoreText":
        var srcButton = aCmd.GetSourceElement();
        var srcTE = srcButton["textedit"];
        // AddMoreTextPanel(srcButton, srcTE, this, 400, 325, 22);
        break;
      case "scrollLeft":
        deltaX += 25 * curZoom;
        portPanel.PanPanel(origPanX, origPanY, deltaX, deltaY);
        break;
      case "scrollRight":
        deltaX += -25 * curZoom;
        portPanel.PanPanel(origPanX, origPanY, deltaX, deltaY);
        break;
      case "scrollUp":
        deltaY += 25 * curZoom * Globals._dpr;
        portPanel.PanPanel(origPanX, origPanY, deltaX, deltaY);
        break;
      case "scrollDown":
        deltaY += -25 * curZoom * Globals._dpr;
        portPanel.PanPanel(origPanX, origPanY, deltaX, deltaY);
        break;
      case "scrollTrack":
        var theScrollBar = aCmd.fSourceElement;
        theScrollBar.HandleTrackClick(aCmd["clientX"], aCmd["clientY"]);
        return;
      default:
        handled = false;
    }

    return handled;
  }

  // call this prior to adding your content to your panel in addcontent function of panel
  GetPaginatedViewPortContent(contentList, maxItemsPerPage) {
    var currentPage = this.GetCurrentPage() > 0 ? this.GetCurrentPage() : 1;
    var maxItems = maxItemsPerPage != null ? maxItemsPerPage : this.fDefaultMaxItemsPerPage;
    var results = contentList instanceof Array ? contentList : [];
    this.fPageCount = Math.ceil(results.length / maxItems);
    this.SetCurrentPage(currentPage);
    return paginateArray(results, maxItems, this.fCurrentPage);
  }

  //================= general paging support
  AddPaginationLinks() {
    // initialize page link variables
    var pageLinkSpace = 15;
    var linkSize = this.GetPageLinkSize();
    var textColor = this.fUseTheme
      ? DetermineTextColor(uFramelessPanelColor)
      : this.fUIColors.GetHeaderTextColor();
    var pageCount = this.fPageCount;
    var pageLinkString = linkSize + "px Arial";
    var nextPrevSize = linkSize + 2;
    var fIconString = fontIconString(nextPrevSize, enumFontIconWeights.regular);
    var currentPage = this.GetCurrentPage();
    var enableLinks = this.fPageCount > 1;

    var shown = this.fNumPageLinksShown;
    var t = this.fPageCount;

    // first we find start and end page numbers
    var prevLink = 1; // start page of previous set of shown links
    var nextLink = shown; // start page of next set of shown links
    var startPage, endPage;
    if (t <= shown) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = t;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= shown - 1) {
        startPage = 1;
        endPage = shown;
      } else if (currentPage >= t) {
        startPage = t - (shown - 1);
        endPage = t;
      } else {
        // calc start and page based on current page
        startPage = 1;
        var startInt = Math.floor(currentPage / shown);
        if (startInt > 0) {
          startPage = startInt * shown;
        }
        endPage = startPage + shown;
        if (endPage > t) endPage = t;
      }

      var calcShown = endPage - startPage + 1;
      var diff = shown - calcShown;
      if (diff > 0 && startPage - diff > 0) {
        startPage = startPage - diff;
      }

      nextLink = endPage;
      prevLink = startPage - shown;
    }

    // next we calc start x position of page links to find center starting point
    var curShownRange = endPage - startPage;
    var availableWidth = this.GetPortWidth();

    var pageLinks = Array.from(Array(pageCount).keys()).slice(startPage, endPage);
    var testStr = pageLinks.join("");
    var textWidth = MeasureText(testStr, pageLinkString) + curShownRange * pageLinkSpace;

    var startX = CenterIt(availableWidth, textWidth) - pageLinkSpace;
    var yPos;

    var pagingButtonHeight = MeasureTextHeight(fIconString, nextPrevSize, kArrowLeftIcon);
    // next we adjust x and y position of page links and paging buttons
    if (this.fPositionPageLinkBelowPort && this.fPortPanel != null) {
      // this is only used by chart / account settings currently because we dont want it in footer
      startX += Div2Floor(this.fPortStartX);
      yPos = this.fPortStartY + this.fPortPanel.GetPortHeight() + kPagingButtonMargin * 2;
    } else {
      yPos =
        this.GetHeight() -
        (this.fFooter ? CenterIt(this.fFooter.GetHeight(), pagingButtonHeight) : 20);
    }
    /*
	// TODO add better positioning support for cases where we have nested panels etc.
	else if (this.fPageLinkPositionRef && this.fPageLinkPositionRef instanceof QPanel || this.fPageLinkPositionRef instanceof QElement)
	{
		startX += Div2Floor(this.fPageLinkPositionRef.GetPositionX());
		yPos = this.fPageLinkPositionRef.GetPositionY() + kPagingButtonMargin*2;
		if (this.fPageLinkPositionRef instanceof QElement)
			yPos += this.GetHeight();
	}
	*/
    // TODO improve hit detection by creating larger invisible padded elements for page links and next/prev arrows
    // position prev page button
    var prevPageButton = this.fPrevButton;
    var linkX = startX - prevPageButton.GetWidth() - pageLinkSpace;
    var linkY = yPos - 4.5;
    var showJumpSet = enableLinks && pageCount > shown;
    prevPageButton.PositionElement(linkX, linkY);

    // add prev set button
    var prevSetButton = this.AddPageSetJumpButton(
      linkX,
      linkY,
      prevLink,
      startPage > 1,
      showJumpSet,
      kDoubleChevronLeft,
      fIconString,
      textColor
    );
    prevSetButton.SetHoverCode("Previous Page Set");
    linkX = prevPageButton.GetPositionX() - prevSetButton.GetWidth() - pageLinkSpace;
    prevSetButton.SetPositionX(linkX);

    var hoverColor = this.fUIColors.GetHoverTextColor();
    // add page links here
    var curX = startX;
    for (var i = startPage; i < endPage + 1; i++) {
      var pageNum = i;
      var activePage = pageNum == currentPage;
      var pageLink = AddLinkText(this, curX, yPos, "JumpToPage", pageNum, linkSize);
      pageLink.fPage = pageNum;
      pageLink.SetItalic(false);
      pageLink.SetBold(activePage);
      pageLink.SetTextColor(activePage && !this.fUseTheme ? hoverColor : textColor);
      if (!this.fUseTheme) pageLink.SetHoverColor(hoverColor);
      curX += pageLink.GetWidth() + pageLinkSpace;
    }

    // format next button
    var nextPage = this.fNextButton;
    nextPage.PositionElement(curX, yPos - 4.5);

    // add next set button
    linkX = nextPage.GetWidthPositionX(pageLinkSpace);
    var nextSetButton = this.AddPageSetJumpButton(
      linkX,
      linkY,
      endPage === pageCount ? endPage : nextLink,
      endPage < pageCount,
      showJumpSet,
      kDoubleChevronRight,
      fIconString,
      textColor
    );
    nextSetButton.SetHoverCode("Next Page Set");
  }

  AddPagingControlButtons() {
    var linkSize = this.GetPageLinkSize();
    var textColor = this.fUseTheme
      ? DetermineTextColor(uFramelessPanelColor)
      : this.fUIColors.GetHeaderTextColor();
    var nextPrevSize = linkSize + 2;
    var fIconString = fontIconString(nextPrevSize, enumFontIconWeights.regular);
    var hoverColor = this.fUIColors.GetHoverTextColor();
    var thePage = this.GetCurrentPage();
    var pageCount = this.GetPageCount();
    var showPagingCtrls = true;

    if (pageCount <= 1) showPagingCtrls = false;

    if (thePage > pageCount) thePage = pageCount;

    var enableNext = false;
    if (thePage < pageCount) enableNext = showPagingCtrls;

    this.fNextButton = AddFloatingViewerIconButton(
      this,
      kArrowRightIcon,
      "NextPage",
      0,
      0,
      "Next Page",
      textColor,
      fIconString
    );
    if (!this.fUseTheme) this.fNextButton.SetHoverColor(hoverColor);
    this.fNextButton.SetShownState(showPagingCtrls);
    this.fNextButton.SetEnabled(enableNext);

    var enablePrev = false;
    if (thePage > 1) enablePrev = showPagingCtrls;

    this.fPrevButton = AddFloatingViewerIconButton(
      this,
      kArrowLeftIcon,
      "PrevPage",
      0,
      0,
      "Previous Page",
      textColor,
      fIconString
    );
    if (!this.fUseTheme) this.fPrevButton.SetHoverColor(hoverColor);
    this.fPrevButton.SetShownState(showPagingCtrls);
    this.fPrevButton.SetEnabled(enablePrev);
  }

  AddPageSetJumpButton(x, y, linkPage, enabled, shown, icon, fIconString, textColor) {
    var jumpSetButton = AddFloatingViewerIconButton(this, icon, "JumpToPage", x, y);
    jumpSetButton.SetEnabled(enabled);
    jumpSetButton.SetShownState(shown);
    if (!this.fUseTheme) jumpSetButton.SetHoverColor(this.fUIColors.GetHoverTextColor());
    jumpSetButton.SetFontColor(textColor);
    jumpSetButton.fFontString = fIconString;
    if (linkPage != null) jumpSetButton.fPage = linkPage;
    return jumpSetButton;
  }

  GetCurrentPage() {
    return this.fCurrentPage;
  }

  PageContent(forward) {
    var curPage = this.GetCurrentPage();

    if (forward) curPage++;
    else curPage--;

    this.SetCurrentPage(curPage);
    this.UpdatePanel();
  }

  GetPageCount() {
    return this.fPageCount;
  }

  IncPageCount() {
    this.fPageCount++;
  }

  ResetPageCount() {
    this.fPageCount = 1;
  }

  SetCurrentPage(thePage) {
    var pageCount = this.GetPageCount();
    if (thePage > pageCount) thePage = pageCount;
    if (thePage !== this.fCurrentPage) {
      this.fCurrentPage = thePage;
      this.DoSetCurrentPage(thePage);
      this.fPortPanel.SetPanY(0);
    }
  }

  DoSetCurrentPage(thePage) {}

  GetPageLinkSize() {
    var size = 12;
    if (this.fLargeLinks) size = 13;
    return size;
  }

  //========================================================================================
  // spawn a simple frameless theme colored panel centered on parent
  InitFramelessPanelBasic(parentPanel, width, height, header, footer, drag, exit, help) {
    this.fParentPanel = parentPanel;
    this.fWSMgr = parentPanel.fWSMgr;
    var panelHeight = height;
    var panelWidth = width;
    this.SizePanel(panelWidth, panelHeight);
    this.SetBorderStyle(enumPanelBorderStyle.framelessBorder);
    this.SetBorderThickness(4);
    this.SetFillColor(uFramelessPanelColor);
    this.SetModalOn(true);
    this.CenterOnBackgroundPanel(parentPanel);
    this.SetFramelessPanelBasics(header, footer, drag, exit, help);
    this.InitializePanel();
  }

  InitializePanel() {
    // override
  }

  ResizePanelFromDelta(deltaX, deltaY) {
    var hX = this.GetPositionX();
    var hY = this.GetPositionY();
    hY = hY + deltaY;
    hX = hX + deltaX;

    var nw = this.fWidth - deltaX;
    this.PositionPanel(hX, hY);
    this.SizePanel(nw, this.fHeight - deltaY);

    this.DoResizePanel();
  }

  SetEnabled(enabled) {
    // TODO also hit panel collection if exists
    this.fEnabled = enabled;
    var numElements = this.fElements.length;
    for (var i = 0; i < numElements; i++) {
      var element = this.fElements[i];
      element.SetEnabled(enabled);
    }
  }

  // TODO we should just incorporate this functionality into the default eg PositionPanel(x,y,keepOnScreen)
  PositionPanelOnScreen(x, y) {
    this.PositionPanel(x, y);
    this.GetPanelOnScreen();
  }

  //===========================================================================
  // call this to ensure panel stays on screen
  GetPanelOnScreen() {
    var xPos = this.GetPositionX();
    var yPos = this.GetPositionY();
    var oldX = xPos;
    var oldY = yPos;

    var deltaX = 0;
    var deltaY = 0;

    var canvas = this.fWSMgr.fCanvas;
    var portHeight = this.fHeight;
    var portWidth = this.fWidth;
    var offscreenTolerance = this.fWindowBorderTolerance;

    var availableHeight = canvas.clientHeight - yPos;
    var availableWidth = canvas.clientWidth - xPos;

    var requiredHeight = portHeight + offscreenTolerance;
    var requiredWidth = portWidth + offscreenTolerance;

    var offScreenBottom = Math.ceil(availableHeight) < requiredHeight;
    var offscreenRight = Math.ceil(availableWidth) < requiredWidth;
    var offscreenLeft = xPos < 0;
    var offscreenTop = yPos < 0;

    var offscreen = {
      bottom: offScreenBottom,
      right: offscreenRight,
      left: offscreenLeft,
      top: offscreenTop
    };

    if (offscreen.bottom && !offscreen.top) {
      deltaY = requiredHeight - availableHeight + offscreenTolerance;
      yPos -= deltaY;
    }
    if (offscreen.right) {
      deltaX = portWidth - availableWidth + offscreenTolerance;
      xPos -= deltaX;
    }

    // These cases shouldnt really happen and are far less common
    if (offscreen.top) {
      yPos = offscreenTolerance;
    }
    if (offscreen.left) {
      xPos = offscreenTolerance;
    }

    if (yPos < 0) yPos = 0;
    if (xPos < 0) xPos = 0;

    this.PositionPanel(xPos, yPos);
    this.PositionAssociatePanels(oldX, oldY, xPos, yPos);
    return offscreen;
  }

  PositionAssociatePanels(oldX, oldY, newX, newY) {
    var associates = this.GetAssociatedPanels();
    for (var idx in associates) {
      var associate = associates[idx];
      var xOffset = associate.GetPositionX() - oldX;
      var yOffset = associate.GetPositionY() - oldY;

      associate.PositionPanel(xOffset + newX, yOffset + newY);
      if (associate.fBackgroundPanel) associate.fBackgroundPanel.UpdatePanel();

      var subAssociates = associate.GetAssociatedPanels();

      if (subAssociates.length > 0) associate.PositionAssociatePanels(oldX, oldY, newX, newY);
    }
  }

  SmartPositionPanel(source) {
    var wsMgr = this.fWSMgr ? this.fWSMgr : this.GetWSMgrRef();
    var canvas = wsMgr.fCanvas;
    var portHeight = this.fHeight;
    var portWidth = this.fWidth;
    var parentPanel = this.fParentPanel;
    var srcPanelRef = source && source.GetParentPanelRef();
    if (srcPanelRef) parentPanel = srcPanelRef;
    var offscreenTolerance = kWebFrameMargin;
    var zoomFactor = 1;
    if (source && parentPanel) {
      zoomFactor = parentPanel.GetScaleFactor();

      var x =
        parentPanel.GetPositionX() +
        (source.GetPositionX() + this.fSourceHBuffer) * zoomFactor -
        parentPanel.GetPanX();
      var y =
        parentPanel.GetPositionY() +
        (source.GetHeight() + source.GetPositionY() + this.fSourceVBuffer) * zoomFactor -
        parentPanel.GetPanY();

      var availableHeight = canvas.clientHeight - y;
      var requiredHeight = portHeight + offscreenTolerance;
      var offScreenBottom = Math.ceil(availableHeight) < requiredHeight;
      if (offScreenBottom) {
        x += source.GetWidth();
      }

      var availableWidth = canvas.clientWidth - x;
      var requiredWidth = portWidth + offscreenTolerance;
      var offscreenRight = Math.ceil(availableWidth) < requiredWidth;
      if (offScreenBottom || offscreenRight) {
        if (offScreenBottom) {
          var deltaV = requiredHeight - availableHeight;
          var vAdjustment = deltaV + offscreenTolerance;
          y -= vAdjustment;
        }
        if (offscreenRight) {
          var deltaH = requiredWidth - availableWidth + offscreenTolerance;
          var fullShift = portWidth + source.GetWidth();
          var hAdjustment = offScreenBottom ? fullShift : deltaH;
          x -= hAdjustment;
        }
      }
    }

    if (y < 0) y = 0;
    if (x < 0) x = 0;

    x = Math.ceil(x);
    y = Math.ceil(y);

    this.PositionPanel(x, y);
    this.SmartPositionPortPanel(x, y);
  }

  SmartPositionPortPanel(x, y) {
    if (!this.fPortPanel) return;
    y += this.fPortStartY;
    this.fPortPanel.DoPositionPanel(x, y);
    this.fPortPanel.fHorzOffset = x;
    this.fPortPanel.fVertOffset = y;
  }

  //======================================================================================================================
  GainFocus() {}

  LoseFocus() {}

  ValidDropTarget() {
    return false;
  }

  GetDragPanelClass() {
    return this;
    // return new QElementDragPanel();
  }

  GetPortSizeDict(endXPos, endYPos) {
    var sizeDict = {};
    sizeDict["width"] = endXPos;
    sizeDict["height"] = endYPos;
    return sizeDict;
  }

  AddCreateButton(x, y, label, cmdCode, hoverCode, icon) {
    var button = AddStdFALabelButton(this, label, icon ? icon : kAddIcon, cmdCode, x, y);
    button.SetFillColor(kCreateButtonColor);
    if (hoverCode != null) button.SetHoverCode(hoverCode);
    return button;
  }

  AddSearchButton(x, y, label, cmdCode, hoverCode) {
    var button = AddStdFALabelButton(this, label, kSearchIcon, cmdCode, x, y);
    if (hoverCode != null) button.SetHoverCode(hoverCode);
    return button;
  }

  AddRoundSearchButton(x, y, label, cmdCode, buttonW, buttonH) {
    var searchButton = AddCustomFALabelButton(this, cmdCode, label, 12, kSearchIcon, x, y);
    searchButton.SetBorderRadius(15);
    searchButton.SizeElement(buttonW, buttonH);
    return searchButton;
  }

  AddDownloadButton(x, y, label, cmdCode, hoverCode) {
    var button = AddStdFALabelButton(this, label, kDownloadFileIcon, cmdCode, x, y);
    button.SetFillColor(kDownloadButtonColor);
    if (hoverCode != null) button.SetHoverCode(hoverCode);
    return button;
  }

  AddAuthenticationButton(x, y, label, cmdCode, hoverCode) {
    var button = AddStdFALabelButton(this, label, kAuthorizationIcon, cmdCode, x, y);
    button.SetFillColor(kDownloadButtonColor);
    if (hoverCode != null) button.SetHoverCode(hoverCode);
    return button;
  }

  AddMoreButton(x, y, cmdCode, hoverCode) {
    var moreButton = AddViewerIconButton(
      this,
      kEllipsisIcon,
      cmdCode,
      x,
      y,
      hoverCode,
      fontIconString(14, enumFontIconWeights.regular)
    );
    moreButton.SetHeight(18);
    return moreButton;
  }

  AddGhostButton(x, y, cmdCode, label, fontIcon, bold, labelSize, color) {
    var buttonColor = color ? color : this.fUIColors.GetPagingBlueColor();
    var button = AddStdFALabelButton(this, label, fontIcon, cmdCode, x, y, labelSize, bold);
    button.SetBorderThickness(1);
    button.SetFillColor(this.GetFillColor());
    button.SetBorderColor(buttonColor);
    button.SetFontColor(buttonColor);
    return button;
  }

  //======================================================================================================================
  // PANEL UI UTILITIES
  AddSearchBar(
    searchStrObj,
    sectionID,
    xPos,
    yPos,
    width,
    blankMsg,
    maxLen,
    height,
    useParentAsRoot
  ) {
    var root = this;
    var addToTabList = false;

    // allows for multiple search bars living on different panels to be able to tab to each other
    if (!useParentAsRoot && this.fBackgroundPanel != null) root = this.fBackgroundPanel;
    if (root.fTabID != null) addToTabList = true;

    if (searchStrObj == null) searchStrObj = root.fSearchStrDict = new QSearchStrDict();
    if (sectionID == null) sectionID = "0";
    var defaultLen = maxLen == null ? 100 : maxLen;
    var defaultTabID = root.GetTabID();
    var defaultMsg = blankMsg == null ? appstr("Find") : blankMsg;

    var searchTE = AddListeningMultiLineTextEdit(
      this,
      xPos,
      yPos,
      width,
      height ? height : 17,
      defaultMsg,
      defaultLen,
      defaultTabID,
      false,
      1
    );
    searchTE.TESetVAlignment("middle");
    searchTE.SetSearchStrInfo(sectionID);
    searchTE.SetSearchStr(searchStrObj);
    if (addToTabList) root.AddToTabList(searchTE);
    searchTE.SetFontIcon(kSearchIcon);
    searchTE.SetBorderRadius(2);
    searchTE.SetBorderStyle(enumElementBorderStyle.roundBorder);
    searchTE.AddClearButton();
    searchTE.fClearButton.SetCmdCode("ClearSearchBarButton");

    return searchTE;
  }

  AddCopyButton(panel, xPos, yPos, cmd, size) {
    var copybutton = AddFramelessCopyButton(panel, cmd, kCopyIcon);
    copybutton.fFontString = fontIconString(size, "400");
    copybutton.SetPositionX(xPos);
    copybutton.SetPositionY(yPos);
    return copybutton;
  }

  AddFACopyButton(panel, xPos, yPos, cmd, iconColor, iconSize, iconWeight) {
    var size = iconSize != null ? iconSize : 16;
    var weight = iconWeight != null ? iconWeight : enumFontIconWeights.light;
    var fs = fontIconString(size, weight);
    return AddFloatingViewerIconButton(
      panel,
      kCopyFileIcon,
      "copy-" + cmd,
      xPos,
      yPos,
      null,
      iconColor,
      fs
    );
  }

  AddLoadingWheel(yOffset, radius) {
    var loadingElement = new QLoadingElement();
    loadingElement.InitIntro(null);

    var offset = 0;
    if (yOffset !== null) offset = yOffset;
    var xPos = CenterIt(this.fWidth, 100);
    var yPos = CenterIt(this.fHeight, 100) + offset;

    loadingElement.PositionElement(xPos, yPos);
    loadingElement.SizeElement(100, 100);
    loadingElement.fLoadingSegmentColor = uFramelessPanelColorDarker;
    loadingElement.fRadius = radius;

    this.PushElement(loadingElement);
    Globals._timerMgr.ClearTimer();
    Globals._timerMgr.SetTimerInterval(kSegmentInterval);
    Globals._timerMgr.StartTimer(loadingElement, true);

    return loadingElement;
  }

  AddCheckbox(posX, posY, theText, textColor, theCmdCode, fontSize, bold, checked) {
    var cB = new QCheckbox();
    cB.InitCheckbox();
    cB.SetBold(bold);
    cB.PositionElement(posX, posY);

    if (fontSize != null) cB.SetFontSize(fontSize);

    cB.SetLabel(theText);
    cB.AutoSize();
    cB.SetCmdCode(theCmdCode);

    if (textColor != null) cB.SetTextColor(textColor);

    if (checked == true) cB.SetChecked(true);

    this.PushElement(cB);

    return cB;
  }

  AddPanelDividerText(x, y, width, label, textColor, lineColor) {
    var dT = new QDividerText();
    dT.InitDividerText();
    dT.SetTextColor(textColor);
    dT.SetAlignment("left");
    dT.PositionElement(x, y);
    dT.SizeElement(width, 16);
    dT.SetFontName(gUIFont);
    dT.SetLabel(label);
    dT.SetBold(true);
    dT.SetLineColor(lineColor);
    this.PushElement(dT);
    return dT;
  }

  AddBasicPanelDividerText(x, y, label, width) {
    var textColor = this.fUIColors.GetHeaderTextColor();
    var lineColor = this.fUIColors.GetAlternativeTextColor();
    return this.AddPanelDividerText(x, y, width, label, textColor, lineColor);
  }

  AddPanelDividerSectionPad(x, y, width, label, defaultPadHeight) {
    var textColor = this.fUIColors.GetHeaderTextColor();
    var lineColor = this.fUIColors.GetAlternativeTextColor();

    this.AddPanelDividerText(x, y, width, label, textColor, lineColor);

    if (defaultPadHeight == null) {
      defaultPadHeight = 30;
    }

    return this.AddSectionElem(x, y + 20, width - 5, defaultPadHeight);
  }

  AddPanelDivider(x, y, dWidth, color, direction, thick) {
    var lineThickness = thick ? 2 : 1;
    var h = direction === enumDividerDirection.vertDivider ? lineThickness : dWidth;
    var v = direction === enumDividerDirection.vertDivider ? dWidth : lineThickness;

    if (!color) {
      color = Globals._themeMode.border;
    }

    var aDivider = new QDivider();
    aDivider.PositionElement(Math.round(x), Math.round(y));
    aDivider.SetFillColor(color);
    aDivider.fStrokeStyle = color;
    aDivider.InitDivider(direction, 0, false);
    aDivider.SizeElement(h, v);
    aDivider.fLineWidth = direction === enumDividerDirection.vertDivider ? h : v;
    aDivider.SetEtchState(false);

    //TODO we should push element here , currently many places rely on pushing element to panel after calling this
    return aDivider;
  }

  // used by panel headers and element pads
  AddSectionPad(xPos, yPos, width, height, color, radius) {
    var aDivider = new QPanelDivider();
    aDivider.InitPanelDivider(
      enumDividerDirection.horzDivider,
      xPos,
      yPos,
      width,
      height,
      color,
      radius
    );
    this.PushElement(aDivider);
    return aDivider;
  }

  AddIconListButton(x, y, imageIndex, hoverCode, cmdCode, sizing, imageFile) {
    var wsMgr = this.fWSMgr;
    var imageMgr = wsMgr.GetImageMgr();

    var a = new QLargeSVGIconButton();
    a.InitXIcon(imageMgr, imageFile);
    a.DoSetImages(imageIndex, sizing);
    a.SizeElement(kLargeWideButtonStandardWidth, kLargeWideButtonStandardHeight);
    a.PositionElement(x, y);
    a.SetHoverCode(hoverCode);
    a.SetCmdCode(cmdCode);
    a.fCenterIcon = false;
    a.fHighlightColor = uFramelessPanelColorLighter;
    this.PushElement(a);

    return a;
  }

  //TODO: There are MANY functions that are trying to achieve something along the lines of adding a divider to a panel.
  // These should be consolidated into one fxn, that takes params which determine the label, headerButton status, section pad, etc.
  AddDividerPanel(panel, x, y, width, label, headerButtons) {
    var headerTextColor = this.fUIColors.GetHeaderTextColor();
    var altTextColor = this.fUIColors.GetPanelBorderColor();

    var dividerWidth = width;
    var includesHeaderButtons = headerButtons != null && headerButtons.length > 0;
    var hBuffer = 5;
    if (includesHeaderButtons) {
      var buttonW = 35;

      var n = headerButtons.length;
      dividerWidth -= Math.ceil(buttonW * n + hBuffer * (n - 1));
    }

    var textColor = headerTextColor;
    var color = altTextColor;

    var dT = new QDividerText();
    dT.InitDividerText();
    dT.SetTextColor(textColor);
    dT.SetAlignment("left");
    dT.PositionElement(x, y);
    dT.SizeElement(dividerWidth, 16);
    dT.SetFontName("Arial");
    dT.SetFontSize(12);
    dT.SetLabel(label);
    dT.SetBold(true);
    dT.SetLineColor(color);
    panel.PushElement(dT);

    if (includesHeaderButtons) {
      var headerStartX = dT.GetWidthPositionX(hBuffer);
      headerButtons.forEach(function (item) {
        item.PositionElement(headerStartX, y - hBuffer);
        headerStartX += item.GetWidth() + hBuffer;
      });
    }

    return dT;
  }

  // element pad used in chart settings and other places
  AddSectionElem(xPos, startY, width, height, radius) {
    var panelFill = this.fUIColors.GetSecondaryPanelFillColor();
    var borderColorLight = this.fUIColors.GetPanelBorderColor();

    var sectionElem = this.AddSectionPad(
      xPos,
      startY,
      width,
      height,
      panelFill,
      radius != null ? radius : 6
    );
    sectionElem.SetBorderColor(borderColorLight);
    return sectionElem;
  }

  AddSVGIconButton(x, y, imageMgr, iconIndex, sizing, label, hoverCode, buttonClass) {
    var wsMgr = this.fWSMgr;
    if (!wsMgr) wsMgr = Globals._wsMgr;
    var sizeW, sizeH; // iconSizeW, iconSizeH;
    var basePanel = this;
    var uiColors = this.fUIColors;
    if (this.fBackgroundPanel && this.fBackgroundPanel.fPortPanel == basePanel)
      basePanel = this.fBackgroundPanel;
    var anIconButton = buttonClass ? new buttonClass() : basePanel.GetIconButtonInstance(); // factory method
    anIconButton.fImageMgr = imageMgr ? imageMgr : wsMgr.GetImageMgr();
    anIconButton.SetBorderThickness(0);
    anIconButton.SetBorderRadius(3);
    anIconButton.SetBorderStyle(enumElementBorderStyle.roundBorder);
    anIconButton.SetBorderColor(uiColors.GetButtonBorderColor());
    anIconButton.SetFillColor(uiColors.GetButtonFillColor());
    anIconButton.fHighlightColor = uiColors.GetHoverTextColor();
    anIconButton.fIsHighlighted = true;
    anIconButton.fParent = this;
    switch (sizing) {
      case enumIconButtonSizing.small:
        sizeW = kSmallButtonStandardSize;
        sizeH = kSmallButtonStandardSize;
        label = "";
        break;
      case enumIconButtonSizing.medium:
        sizeW = kSmallButtonStandardSize;
        sizeH = kSmallButtonStandardSize;
        label = "";
        break;
      case enumIconButtonSizing.large:
        sizeW = kLargeButtonStandardSize;
        sizeH = kLargeButtonStandardSize;
        break;
    }

    //anIconButton.SetSizing(sizing);
    var hasLabel = false;
    if (label != "") {
      hasLabel = true;
      sizeH = sizeH + kbuttonLabelHeight;
    }

    anIconButton.PositionElement(x, y);
    anIconButton.SizeElementMinSize(sizeW, sizeH);

    var imageElem = anIconButton.DoSetImages(iconIndex, sizing);
    anIconButton.PushElement(imageElem);

    if (hasLabel) {
      anIconButton.SetLabel(label);
      anIconButton.SetShowLabel(true);
    }
    if (hoverCode) anIconButton.SetHoverCode(hoverCode);

    //anIconButton.AutoSize();
    anIconButton.SizeElement(sizeH + 16, sizeW + 16);
    anIconButton.SetFontColor(uiColors.GetBodyTextColor()); // TODO needs to call uicolors obj
    this.PushElement(anIconButton);
    return anIconButton;
  }

  GetIconButtonInstance() {
    /// override this if desired
    var buttonClass = new QXIconButton();
    return buttonClass;
  }

  // used for buttons with underline pad and bold animate hover ( see planning activity tab ribbon switcher )
  AddViewerAnimateTextButton(xPos, yPos, label, cmdCode, txtColor, hoverCode, fontString) {
    var button = new QAnimateTextButton();
    button.InitBasicButton(this, label, cmdCode, xPos, yPos);
    button.SetBorderStyle(enumElementBorderStyle.roundBorder);
    button.SetBorderRadius(3);
    button.SetBorderThickness(0);
    button.SetBorderColor(this.GetFillColor());
    if (fontString != null) button.fFontString = fontString;
    button.fTxtFillStyle = txtColor ? txtColor : DetermineTextColor(this.GetFillColor());
    button.fLabelPosition = enumButtonLabelPosition.center;
    return button;
  }

  // use for creating tab buttons (see 'AddFramelessTabs' for creating tab groups)
  AddPanelTabButton(label, cmdCode, x, y, buttonW, buttonH) {
    //standard button - call using addsmartframelesstab for groups / rows of them
    var button = new QPanelTabButton();
    button.InitTabButton(this, label, cmdCode, x, y, buttonW, buttonH);
    button.SetFillColor(uFramelessPanelColor);
    button.fTxtFillStyle = DetermineTextColor(uFramelessPanelColor);
    button.SetBorderThickness(2);
    button.SetBorderStyle(enumElementBorderStyle.singleBorder);
    button.SetBorderRadius(4);
    button.fPanelTab = true;
    button.fLabelPosition = enumButtonLabelPosition.center;
    button.fCurCursor = "pointer";
    this.PushElement(button);
    return button;
  }

  AddSmartTabs(xPos, yPos, availWidth, optionsDict, numRows, fs, fillPad) {
    var buttonH = 23;
    var tabFontString = fs ? fs : "12px Verdana";
    var n = Object.keys(optionsDict).length;
    var spacing = 2;

    var spaceSize = availWidth - 2 * xPos;
    var offset = xPos;
    var optionsPerRow = n / numRows;
    var buttonW = Math.floor((spaceSize - (optionsPerRow - 1) * spacing) / optionsPerRow);
    var textColor = this.fUIColors.GetHeaderTextColor();
    var rowCounter = 1;
    for (var aTab in optionsDict) {
      var section = aTab;
      var isCurrentTab = section === this.fCurrentTab;
      var label = optionsDict[aTab]; // optionsDict is a dictionary, key is the section name, value is the label
      //label, 'section-'+section, xPos, yPos, buttonW, buttonH
      var tabButton = this.AddViewerAnimateTextButton(
        xPos,
        yPos,
        label,
        "section-" + section,
        textColor,
        "",
        tabFontString
      );
      if (fillPad) {
        var fillColor = shadeColor(this.fUIColors.GetLightPanelBorderColor(), 17);
        tabButton.fStdFillColor = fillColor;
        tabButton.SetBorderStyle(enumElementBorderStyle.roundBorder);
        tabButton.SetBorderThickness(1);
        tabButton.SetBorderColor(fillColor);
      }
      tabButton.fUnderlineColor = this.fUIColors.GetLinkTextBlueColor();
      tabButton.fIsActive = isCurrentTab;
      tabButton.SetWidth(buttonW);
      xPos += buttonW + spacing;
      if (rowCounter >= optionsPerRow) {
        yPos += buttonH + spacing;
        xPos = offset;
        rowCounter = 1;
      } else rowCounter += 1;
    }

    return yPos;
  }

  // use for creating tab button groups
  AddSmartFramelessTabs(xPos, yPos, availWidth, optionsDict, numRows) {
    var buttonH = 23;
    var n = Object.keys(optionsDict).length;
    var spacing = 2;

    var spaceSize = availWidth - 2 * xPos;
    var offset = xPos;
    var optionsPerRow = n / numRows;
    var buttonW = Math.floor((spaceSize - (optionsPerRow - 1) * spacing) / optionsPerRow);

    var rowCounter = 1;
    for (var aTab in optionsDict) {
      var section = aTab;
      var label = optionsDict[aTab]; // optionsDict is a dictionary, key is the section name, value is the label
      var tabButton = this.AddPanelTabButton(
        label,
        "section-" + section,
        xPos,
        yPos,
        buttonW,
        buttonH
      );
      tabButton.fIsActive = section === this.fCurrentTab;
      xPos += buttonW + spacing;
      if (rowCounter >= optionsPerRow) {
        yPos += buttonH + spacing;
        xPos = offset;
        rowCounter = 1;
      } else rowCounter += 1;
    }

    return yPos;
  }

  // Drag n drop hover box
  AddHoverBox(panel, posX, posY, width, height, zPlane, layer) {
    var uR = new QHoverBox();
    uR.initRectElement(panel, posX, posY, width, height);
    uR.PositionElement(posX, posY);
    uR.SizeElement(width, height);
    uR.SetShownState(true);
    if (layer) uR.SetLayer(layer);
    if (zPlane != null) uR.SetZPlane(zPlane);
    panel.PushElement(uR);
    return uR;
  }

  AddToggleSwitch(xPos, yPos, label, cmdCode, toggleOn, enabled, bold, color) {
    var uiColors = Globals._wsMgr.GetUIColors();

    var fN = "Arial";
    var fS = 13;

    var defaultTextColor = color ? color : uiColors.GetHeaderTextColor();

    var toggleSwitchElemObj = {};

    var toggleLabel = AddStaticText2(this, xPos, yPos, label, bold, defaultTextColor, fN, fS);

    toggleSwitchElemObj["label"] = toggleLabel;

    yPos += toggleLabel.GetHeight() + 5;

    var switchColor = enabled
      ? toggleOn
        ? uiColors.GetSuccessTextColor()
        : Globals._themeMode.border
      : Globals._themeMode.lightborder;
    var textColor = enabled ? uiColors.GetHeaderTextColor() : Globals._themeMode.text.disabled;

    var fIconStyle = toggleOn
      ? fontIconString(20, enumFontIconWeights.bold)
      : fontIconStringDuotone(20);

    var toggleSwitch = AddFloatingViewerIconButton(
      this,
      toggleOn ? kToggleOnIcon : kToggleOffIconDuo,
      cmdCode,
      xPos,
      yPos,
      null,
      switchColor,
      fIconStyle
    );
    toggleSwitch.SetEnabled(enabled);

    toggleSwitchElemObj["switch"] = toggleSwitch;

    var toggleStateStr = AddStaticText2(
      this,
      toggleSwitch.GetWidthPositionX(),
      yPos,
      toggleOn ? appstr("on") : appstr("Off"),
      false,
      textColor,
      fN,
      fS
    );
    toggleStateStr.SetPositionY(
      yPos + CenterIt(toggleSwitch.GetHeight(), toggleStateStr.GetHeight()) + 2
    );

    toggleSwitchElemObj["stateStr"] = toggleStateStr;

    BufferViewerEleHorzPos([toggleSwitch, toggleStateStr], 3);

    toggleSwitchElemObj["height"] = toggleLabel.GetHeight() + toggleSwitch.GetHeight() + 5;

    return toggleSwitchElemObj;
  }

  AddPadlessButton(xPos, yPos, width, height, label, cmdCode, doDropdown, font, bold = false) {
    var stdButton = new QPadlessButton();
    stdButton.PositionElement(xPos, yPos);
    stdButton.SizeElement(width, height);
    stdButton.fDoDropdown = doDropdown == true; //force bool
    if (bold === true) stdButton.SetBold(true);
    stdButton.SetLabel(label);
    stdButton.SetCmdCode(cmdCode);
    stdButton.SetFillMode(enumFillMode.noFill);
    stdButton.SetFillColor(this.GetFillColor());
    var margin = 6;
    if (doDropdown && (!font || (font && !font.includes("Font Awesome")))) {
      margin = 15;
    }
    stdButton.SetMarginH(margin);
    if (this.fPanelTheme) {
      stdButton.SetStdFillColor(this.fPanelTheme.button.fill);
      if (!this.fPanelTheme.button.border) {
        stdButton.SetBorderStyle(enumElementBorderStyle.noBorder);
        stdButton.SetBorderThickness(0);
      } else stdButton.SetBorderColor(this.fPanelTheme.button.border);
    }
    stdButton.SetFontColor(DetermineTextColor(stdButton.fStdFillColor));
    stdButton.SetBorderRadius(4);
    stdButton.SetBorderThickness(0);
    stdButton.SetHAlignment("center");
    stdButton.SetBorderStyle(enumElementBorderStyle.roundBorder);
    if (font) {
      stdButton.fFontString = font;
    } else {
      stdButton.SetFontSize(12.5);
      stdButton.SetFontName(gUIFont);
    }

    if (!width) stdButton.AutoSize();
    stdButton.fParentPanel = this;

    this.PushElement(stdButton);

    return stdButton;
  }

  //  HEADERS ============================================================================================================
  addFramelessHeader(label, fs) {
    var fontString = fs ? fs : BuildFontString(gUIFont, 12, true, false);
    var elemWidth = this.fWidth;
    var maxWidth = elemWidth - 2 * kFramelessDropDownMarginH;
    var labelStr = TruncateText(label, fontString, maxWidth);
    var txtFillStyle = DetermineTextColor(uFramelessPanelColor);
    var headerElement = AddStaticText(this, 0, 0, labelStr, true, txtFillStyle);
    var textW = MeasureText(label, fontString);
    if (textW > maxWidth) {
      headerElement.SetRawHoverValue(label);
    }
    headerElement.SetAlignment("center");
    headerElement.SizeElement(elemWidth, kFramelessHeaderHeight);
    headerElement.SetFillMode(enumFillMode.solidFill);
    headerElement.SetFillColor(uFramelessPanelColorDarker);
    headerElement.fFontString = fontString;
    return headerElement;
  }

  // SHAPES & EFFECTS  ===================================================================================================
  AddPanelHeader(height, headerString, headerFontSize, color, radius, alignment, x) {
    var headerPad = this.AddSectionPad(0, 0, this.fWidth, height, color, radius);
    if (headerString) {
      var cornerButton = 35;
      var buttonSpacing = 15;
      var fontString = BuildFontString("Verdana", headerFontSize, false, false);
      var maxWidth = headerPad.GetWidth() - 2 * kFramelessDropDownMarginH;
      if (this.fHasExit) {
        maxWidth -= cornerButton + buttonSpacing;
      }
      if (this.fHelpCode) {
        maxWidth -= cornerButton + buttonSpacing;
      }

      var labelStr = TruncateText(headerString, fontString, maxWidth);

      var headerStaticText = AddStaticText(
        headerPad,
        x ? x : kIndent * 2,
        0,
        labelStr,
        false,
        DetermineTextColor(color)
      );
      headerStaticText.fFontString = fontString;
      headerStaticText.SizeElement(headerPad.GetWidth(), height);
      headerPad.fLabel = headerStaticText;
      if (alignment === "center") {
        headerStaticText.SetPositionX(0);
        headerStaticText.SetAlignment("center");
      }
    }
    return headerPad;
  }

  AddSectionMarker(xPos, yPos, width, height, color, radius) {
    var sectionMarker = this.AddPanelHeader(height, null, null, color, radius);
    sectionMarker.SizeElement(width, height);
    sectionMarker.PositionElement(xPos, yPos);
    return sectionMarker;
  }

  //======================================================================================================================
  AddMenuButton(x, y, label, cmdCode, width, height, fs) {
    var menuButton = new QMenuButton();
    menuButton.InitMenuButton(this, label, cmdCode, x, y, width, height, fs);
    menuButton.SetFillColor(this.GetFillColor());
    this.PushElement(menuButton);
    return menuButton;
  }
}
